// import { useEffect, useMemo, useState, useRef } from 'react';
// import { Box, Typography, Button, CircularProgress, Paper, Grid, IconButton, Stack, Tooltip, Snackbar, Alert, Checkbox, Collapse } from '@mui/material';
// import DeleteIcon from '@mui/icons-material/Delete';
// import { DataGrid } from '@mui/x-data-grid';
// import { useNavigate, Link } from 'react-router-dom';
// import axios from 'axios';
// import { FaUser } from 'react-icons/fa';
// import { VscNewFile } from 'react-icons/vsc';
// import { useMediaQuery, useTheme } from '@mui/material';
// import { useAuth } from '../../context/AuthContext';
// import PdfViewer from '../../components/PdfViewer';

// const normalizeDate = (v) =>
//     typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v)
//         ? v.split('-').reverse().join('/')
//         : v || '-';


// export default function PurcDispatchDetails({ connectionString, pdfString }) {
//     const { user, selectedCompany } = useAuth();
//     const userId = user?.UserId || null;
//     const companyId = selectedCompany?.CompId || null;
//     const API_URL = `${connectionString}/api`;

//     // State variables for managing orders, loading states, selections, and UI feedback
//     const role = user?.UserCategory || null;
//     const [orders, setOrders] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [showPending, setShowPending] = useState(false);
//     const [pendingOrders, setPendingOrders] = useState([]);
//     const [loadingPending, setLoadingPending] = useState(false);
//     const [pendingFetched, setPendingFetched] = useState(false);
//     const [selectedRows, setSelectedRows] = useState([]);
//     const [selectedRowIds, setSelectedRowIds] = useState([]);
//     const [challanRows, setChallanRows] = useState([]);
//     const [challanLoading, setChallanLoading] = useState(true);
//     const [challanSelectionModel, setChallanSelectionModel] = useState([]);
//     const [snackbarOpen, setSnackbarOpen] = useState(false);
//     const [snackbarMessage, setSnackbarMessage] = useState('');
//     const [snackbarSeverity, setSnackbarSeverity] = useState('success');
//     const [pdfOverlayVisible, setPdfOverlayVisible] = useState(false);
//     const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
//     const [pdfUri, setPdfUri] = useState(null);
//     const [pdfLoading, setPdfLoading] = useState(false);
//     const [pdfError, setPdfError] = useState(null);
//     const newWinRef = useRef(null);
//     const revokeIntervalRef = useRef(null);

//     const theme = useTheme();
//     const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
//     const isMobile = useMediaQuery('(max-width:600px)');
//     const navigate = useNavigate();
//     const params = { userId, userCategory: role, companyId };

//     useEffect(() => {
//         // Fetch and normalize purchase orders
//         (async () => {
//             setLoading(true);
//             try {
//                 const res = await axios.get(`${API_URL}/Purchaseorders`, { params: { ...params, mode: "ref", }, headers: { 'Cache-Control': 'no-store' } });
//                 const raw = Array.isArray(res.data) ? res.data : [];
//                 const rows = raw.map(r => {
//                     const soId = r.SOId ?? r.SOAutoID ?? r.id ?? r.POId;
//                     return { ...r, id: String(r.POId), SOId: Number(r.POId), SOAutoID: Number(soId), BillAmt: Number(r.BillAmt) || 0, clientId: Number(r.PartyID), };
//                 });
//                 console.log('normalized orders rows:', rows);
//                 setOrders(rows);
//                 setPendingOrders(rows);
//             } catch (err) {
//                 console.error('❌ Failed to fetch orders', err);
//                 setOrders([]);
//                 setPendingOrders([]);
//             } finally {
//                 setLoading(false);
//                 setLoadingPending(false);
//             }
//         })();
//     }, []);

//     useEffect(() => {
//         return () => {
//             if (revokeIntervalRef.current) clearInterval(revokeIntervalRef.current);
//             if (pdfUri) URL.revokeObjectURL(pdfUri);
//             if (newWinRef.current && !newWinRef.current.closed) newWinRef.current.close();
//         };
//     }, [pdfUri]);

//     useEffect(() => {
//         // Fetch and normalize challan data
//         (async function fetchChallans() {
//             try {
//                 const res = await axios.get(`${API_URL}/Purchase-dispatch`, { params, headers: { 'Cache-Control': 'no-store' } });
//                 const data = Array.isArray(res.data) ? res.data : [];
//                 console.log(data);
//                 const rows = data.map((row, idx) => ({
//                     // Ensure the row contains ChallanId AND id (both the same value)
//                     id: row.ChallanId ?? idx,
//                     ChallanId: row.ChallanId ?? idx,          // <-- add this
//                     ChallanAutoID: row.ChallanId ?? idx,
//                     ChallanNumber: row.ChallanNumber,
//                     RefNo: row.RefNo,
//                     ChallanDate: row.ChallanDate ? new Date(row.ChallanDate).toLocaleDateString('en-GB') : '',
//                     FirmName: row.FirmName,                   // keep original DB keys if you reference them elsewhere
//                     ContactPerson: row.ContactPerson,
//                     MobileNo: row.MobileNo,
//                     City: row.City,
//                     state: row.state,
//                     BillAmt: Number(row.BillAmt) || 0,
//                     PartyID: row.PartyID,
//                     clientId: row.PartyID,
//                 }));
//                 setChallanRows(rows);
//             } catch (err) {
//                 console.error('Error fetching challans:', err);
//             } finally {
//                 setChallanLoading(false);
//             }
//         })();
//     }, []);

//     // Toggle visibility of pending orders section
//     const handleTogglePending = () => { setShowPending(prev => !prev); };

//     // Navigate to dispatch page with selected orders
//     const handleDispatch = () => {
//         if (selectedRows.length === 0) return;

//         const firstOrder = selectedRows[0];
//         const selectedPOIds = selectedRows.map(r => r.POId);

//         // robust clientId extraction (cover different possible keys)
//         const clientId = firstOrder.clientId ?? firstOrder.PartyID ?? firstOrder.partyIdRaw ?? null;

//         if (!clientId) {
//             setSnackbarMessage('Selected order does not have a clientId — cannot proceed.');
//             setSnackbarSeverity('warning');
//             setSnackbarOpen(true);
//             return;
//         }
//         console.log(clientId, selectedPOIds);
//         // navigate to the dispatch stepper. Use clientId as route param and pass selected ids in state
//         navigate(`/main/Purchase-ChallanMaster-stepper-ref/${clientId}`, { state: { selectedPOIds } });
//     };

//     // Open challan view in new tab
//     // const handleView = (id) => { window.open(`${window.location.origin}/Purchase-Dispatch-Order/${id}`, '_blank'); };

//     const handleView = async (challanId) => {
//         if (isGeneratingPdf || !challanId) return;

//         setPdfOverlayVisible(true);
//         setIsGeneratingPdf(true);
//         setPdfError(null);
//         setPdfUri(null);

//         const userIdSafe = userId || 'usr1';

//         // ───── Format detection (same as other docs) ─────
//         let formatId = 'format_1';
//         let bookNameToSend = 'PurchaseDispatch';
//         let bookIdToSend = null;

//         try {
//             const found = challanRows.find(r => Number(r.ChallanId) === Number(challanId));
//             if (found?.BookName) bookNameToSend = String(found.BookName).trim();
//             else if (found?.bookName) bookNameToSend = String(found.bookName).trim();
//         } catch (e) { }

//         try {
//             const resp = await axios.get(`${API_URL}/companies`, { params: { companyId } });
//             const comps = Array.isArray(resp?.data?.companies) ? resp.data.companies :
//                 Array.isArray(resp?.data) ? resp.data : [resp.data].filter(Boolean);

//             const eq = (a, b) => String(a ?? '').trim().toLowerCase() === String(b ?? '').trim().toLowerCase();
//             let matched = null;

//             for (const c of comps) {
//                 if (Array.isArray(c.formats)) {
//                     for (const f of c.formats) {
//                         if (eq(f.BookName || f.bookName, bookNameToSend) ||
//                             eq(f.FormName || f.formName, "PurchaseDispatch") ||
//                             String(f.FormName || '').toLowerCase().includes('purchasedispatch')) {
//                             matched = f;
//                             break;
//                         }
//                     }
//                     if (matched) break;
//                 }
//                 if (eq(c.BookName || c.bookName, bookNameToSend)) { matched = c; break; }
//             }

//             if (matched) {
//                 const id = matched.BookID ?? matched.BookId ?? matched.bookId;
//                 if (id) { formatId = `format_${id}`; bookIdToSend = id; }
//                 else if (matched.FormName || matched.formName) formatId = String(matched.FormName || matched.formName);
//                 bookNameToSend = matched.BookName || matched.bookName || bookNameToSend;
//             }
//         } catch (err) {
//             console.warn("Format detection failed → using defaults");
//         }

//         try {
//             setPdfLoading(true);

//             // 1. Fetch full challan data from your MAIN backend
//             const { data } = await axios.get(`${API_URL}/get-purdispatch-data/${challanId}`, {
//                 params: { companyId },
//                 headers: { 'Cache-Control': 'no-store' }
//             });

//             const { master, items = [], details } = data || {};
//             if (!master) throw new Error("No master data returned");

//             // 2. Fetch company logo (optional)
//             let imageBase64 = null;
//             try {
//                 const iconRes = await axios.get(`${API_URL}/company/GetIcon/${companyId}`);
//                 if (iconRes?.data?.success && iconRes?.data?.imageBase64) {
//                     imageBase64 = iconRes.data.imageBase64.replace(/^data:image\/\w+;base64,/, '');
//                 }
//             } catch (e) { /* ignore */ }

//             // 3. Build PDF payload (exactly the shape your PDF server expects)
//             const transformedItems = (items.length ? items : details || []).map(d => ({
//                 ItemCode: d.itemCode || "",
//                 productImage: d.productImage || "",
//                 hsnCode: d.HSN || "",
//                 description: d.description || d.productDescription || "",
//                 qty: Number(d.Qty) || 0,
//                 unit: d.UnitValue || "",
//                 rate: Number(d.Rate) || 0,
//                 discount: Number(d.Disc) || 0,
//                 cgst: Number(d.CGST) || 0,
//                 sgst: Number(d.SGST) || 0,
//                 igst: Number(d.IGST) || 0,
//                 amount: Number(d.ItemTotal) || 0,
//             }));

//             const pdfData = {
//                 companyId,
//                 companyName: master?.clientDetails?.clientname || master?.FirmName || master?.PartyName || "",
//                 address: master?.clientDetails?.address || master?.Address || "",
//                 phone: master?.clientDetails?.mobileNo || master?.MobileNo || "",
//                 gstNo: master?.clientDetails?.gstno || master?.GSTNo || "",
//                 invoiceNo: master?.ChallanNumber || "",
//                 referrenceNo: master?.PartyPONO || master?.RefNo || "",
//                 date: master?.ChallanDate ? normalizeDate(master.ChallanDate) : "",
//                 transport: "SELF",
//                 challanNo: master?.ChallanNumber || "",
//                 poNo: master?.PartyPONO || "",
//                 state: master?.clientDetails?.state || master?.state || "",
//                 stateCode: master?.clientDetails?.stateCode || master?.StateCode || "",
//                 LrNo: master?.LRNo || "",
//                 vehNo: master?.VehicleNo || "",
//                 LrDate: master?.DeliveryDate ? normalizeDate(master.DeliveryDate) : "",
//                 shipToGstNumber: master?.clientDetails?.gstno || "",
//                 shipToState: master?.clientDetails?.state || "",
//                 items: transformedItems,
//                 toEmail: master?.clientDetails?.emailId || "",
//                 totalAmount: Number(master?.BillAmt) || 0,
//                 mobileNo: master?.clientDetails?.mobileNo || "",
//                 BasicAmt: Number(master?.BasicAmt) || 0,
//                 CGSTAmt: Number(master?.CGSTAmt) || 0,
//                 SGSTAmt: Number(master?.SGSTAmt) || 0,
//                 IGSTAmt: Number(master?.IGSTAmt) || 0,
//                 RoundOff: Number(master?.RoundOff) || 0,
//                 BillAmt: Number(master?.BillAmt) || 0,
//                 clientState: master?.clientState || "",
//                 imageBase64: imageBase64 || null,
//             };

//             // 4. POST full data to your PDF backend
//             const pdfResp = await axios.post(
//                 `${pdfString}/api/pdf/PurchaseDispatch/${challanId}`,
//                 {
//                     docId: challanId,
//                     userId: userIdSafe,
//                     formatId,
//                     data: pdfData,
//                     company: {
//                         CompanyName: selectedCompany?.CompanyName || selectedCompany?.companyName || "",
//                         Address: selectedCompany?.Address || selectedCompany?.address || "",
//                         MobileNo: selectedCompany?.MobileNo || selectedCompany?.mobileNo || "",
//                         GSTNo: selectedCompany?.GSTNo || selectedCompany?.gstNo || "",
//                         imageBase64: imageBase64 || null
//                     }
//                 },
//                 { responseType: "blob", timeout: 120000 }
//             );

//             const blob = pdfResp.data;
//             if (!blob || blob.size === 0) throw new Error("Empty PDF");

//             const blobUrl = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));

//             const newWin = window.open("", "_blank");
//             if (newWin) {
//                 newWinRef.current = newWin;
//                 newWin.location.href = blobUrl;
//                 newWin.focus();

//                 const checker = setInterval(() => {
//                     if (newWin.closed) {
//                         URL.revokeObjectURL(blobUrl);
//                         clearInterval(checker);
//                         newWinRef.current = null;
//                     }
//                 }, 1000);
//                 revokeIntervalRef.current = checker;
//             } else {
//                 if (pdfUri) URL.revokeObjectURL(pdfUri);
//                 setPdfUri(blobUrl);
//                 setSnackbarMessage("Popup blocked — showing inline");
//                 setSnackbarSeverity("warning");
//                 setSnackbarOpen(true);
//             }

//         } catch (err) {
//             console.error("Purchase Challan PDF error:", err);
//             setPdfError("Failed to generate PDF");
//             setSnackbarMessage("Could not load PDF. Please try again.");
//             setSnackbarSeverity("error");
//             setSnackbarOpen(true);
//         } finally {
//             setPdfOverlayVisible(false);
//             setIsGeneratingPdf(false);
//             setPdfLoading(false);
//         }
//     };

//     // Delete selected challans with confirmation and feedback
//     const handleChallanDelete = async (objAryId) => {
//         if (!objAryId.length || !window.confirm(`Are you sure you want to delete ${objAryId.length} challan(s)?`)) return;
//         const numericIds = objAryId.map(Number);
//         try {
//             const payload = { objAryId: numericIds, companyId };
//             const { data } = await axios.post(`${API_URL}/delete-PurchaseDispatch`, payload);
//             const totalDeleted = (data.deletedChallanDetails || 0) + (data.deletedChallans || 0);
//             if (totalDeleted > 0) {
//                 setChallanRows(prev => prev.filter(row => !numericIds.includes(Number(row.ChallanAutoID))));
//                 setChallanSelectionModel(prev => prev.filter(id => !numericIds.includes(id)));
//                 setSnackbarMessage(`Deleted ${totalDeleted} challan(s) successfully.`);
//                 setSnackbarSeverity('success');
//             } else if (data.referencedIds && data.referencedIds.length > 0) {
//                 setSnackbarMessage(data.message);
//                 setSnackbarSeverity('info');
//             } else {
//                 setSnackbarMessage('No challans were deleted, references exist.');
//                 setSnackbarSeverity('info');
//             }
//             setSnackbarOpen(true);
//         } catch (err) {
//             console.error('Error deleting challans:', err);
//             setSnackbarMessage(`Failed to delete one or more challans: ${err.response?.data?.message || err.message}`);
//             setSnackbarSeverity('error');
//             setSnackbarOpen(true);
//         }
//     };

//     // Close snackbar handler
//     const handleSnackbarClose = (event, reason) => {
//         if (reason === 'clickaway') return;
//         setSnackbarOpen(false);
//     };

//     // Handle individual row selection with clientId check — toggle only the single row
//     const handleRowSelection = (row, checked) => {
//         // normalize IDs to strings for consistent comparisons
//         const rowClientId = String(row.clientId ?? row.PartyID ?? '');
//         const rowPOIdStr = String(row.POId ?? '');  // Use POId

//         if (checked) {
//             // If there is already a selected row, ensure clientId matches first selected
//             if (selectedRows.length > 0) {
//                 const firstClientId = String(selectedRows[0].clientId ?? selectedRows[0].PartyID ?? '');
//                 if (rowClientId !== firstClientId) {
//                     setSnackbarMessage('Cannot select orders with different Client IDs.');
//                     setSnackbarSeverity('warning');
//                     setSnackbarOpen(true);
//                     return;
//                 }
//             }

//             // Add this row if not already present
//             setSelectedRows(prev => {
//                 const exists = prev.some(r => String(r.POId ?? '') === rowPOIdStr);
//                 return exists ? prev : [...prev, row];
//             });
//             setSelectedRowIds(prev => prev.includes(rowPOIdStr) ? prev : [...prev, rowPOIdStr]);
//         } else {
//             // Remove only this row
//             setSelectedRows(prev => prev.filter(r => String(r.POId ?? '') !== rowPOIdStr));
//             setSelectedRowIds(prev => prev.filter(id => id !== rowPOIdStr));
//         }
//     };

//     const columns = [
//         {
//             field: 'select', headerName: '', width: 50, sortable: false, disableColumnMenu: true,
//             renderHeader: () => {
//                 // normalize all pendingOrders ids to string for consistent checks
//                 const allSelected = pendingOrders.length > 0 && pendingOrders.every(row => selectedRowIds.includes(String(row.POId ?? '')));
//                 const someSelected = selectedRowIds.length > 0 && !allSelected;

//                 return (
//                     <Checkbox checked={allSelected} indeterminate={someSelected}
//                         onChange={(e) => {
//                             const checked = e.target.checked;
//                             if (checked) {
//                                 // determine clientId to match. prefer currently selected client (if any) else first pending order
//                                 const firstClientId = selectedRows.length > 0 ? String(selectedRows[0].clientId ?? selectedRows[0].PartyID ?? '') : String(pendingOrders[0]?.clientId ?? pendingOrders[0]?.PartyID ?? '');

//                                 if (!firstClientId) {
//                                     // nothing to select
//                                     setSelectedRows([]);
//                                     setSelectedRowIds([]);
//                                     return;
//                                 }

//                                 const validRows = pendingOrders.filter(row => String(row.clientId ?? row.PartyID ?? '') === firstClientId);
//                                 setSelectedRows(validRows);
//                                 setSelectedRowIds(validRows.map(row => String(row.POId ?? '')));

//                                 if (validRows.length < pendingOrders.length) {
//                                     setSnackbarMessage('Selected orders with matching Client ID only.');
//                                     setSnackbarSeverity('info');
//                                     setSnackbarOpen(true);
//                                 }
//                             } else {
//                                 setSelectedRows([]);
//                                 setSelectedRowIds([]);
//                             }
//                         }}
//                     />
//                 );
//             },
//             renderCell: ({ row }) => {
//                 const rowIdStr = String(row.POId ?? '');
//                 const checked = selectedRowIds.includes(rowIdStr);
//                 return (<Checkbox checked={checked} onChange={(e) => handleRowSelection(row, e.target.checked)} />);
//             },
//         },
//         {
//             field: "PODate", headerName: "Order Date", flex: 0.8, sortable: true,
//             valueFormatter: (params) => {
//                 const v = params.value;
//                 if (typeof v !== "string" || !v.includes("-")) return "-";
//                 const [yyyy, mm, dd] = v.split("-");
//                 return `${dd}/${mm}/${yyyy}`;
//             },
//         },
//         {
//             field: "PONumber", headerName: "Order No.", flex: 1.2,
//             renderCell: (params) => (
//                 <Box onClick={(e) => {
//                     e.stopPropagation();
//                 }} sx={{ textDecoration: 'underline' }}>
//                     {params.value}
//                 </Box>
//             ),
//         },
//         { field: "PartyPONO", headerName: "Ref No.", flex: 1 },
//         {
//             field: "PartyName", headerName: "Client Details", flex: 2.5,
//             renderCell: (params) => (
//                 <Box sx={{ cursor: 'pointer', whiteSpace: 'normal', wordBreak: 'break-word', my: 1 }}>
//                     <Typography variant="subtitle2" sx={{ fontSize: '0.85rem' }}> {params.row.PartyName || '-'} </Typography>
//                     <Stack direction="row" alignItems="center" spacing={1}>
//                         <FaUser color="#FF9800" />
//                         <Typography variant="body2">{params.row.ContactPerson || '-'}</Typography>
//                     </Stack>
//                     <Typography variant="body2" color="text.secondary"> 📲 {params.row.MobileNo || '-'} </Typography>
//                 </Box>
//             ),
//         },
//         {
//             field: "location", headerName: "Location", flex: 1.5, sortable: true,
//             renderCell: (params) => (
//                 <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                     <Typography variant="body2">{params.row.City || '-'}</Typography>
//                     <Typography variant="caption" sx={{ color: '#666' }}>{params.row.state || '-'}</Typography>
//                 </Box>
//             ),
//         },
//         ...(user?.UserCategory !== "SalesMan" ? [{
//             field: "BillAmt", headerName: "Total Amt", flex: 1, align: "right", headerAlign: "right",
//             valueFormatter: (params) => {
//                 let num = params.value;
//                 if (typeof num === "string") num = parseFloat(num);
//                 if (typeof num !== "number" || isNaN(num)) return "-";
//                 return `₹${num.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
//             },
//         }] : []),
//     ];

//     const challanColumns = [
//         { field: 'ChallanDate', headerName: 'Date', flex: 0.8, sortable: true },
//         {
//             field: 'ChallanNumber', headerName: 'Challan Number', flex: 1.2,
//             renderCell: (params) => (
//                 <Box>
//                     <Typography variant="body2" sx={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer', '&:hover': { opacity: 0.85 } }}
//                         onClick={(e) => {
//                             e.stopPropagation();
//                             // navigate to your route and pass clientId in state
//                             navigate(`/main/Purchase-ChallanMaster-edit/${params.row.ChallanAutoID}`, { state: { clientId: params.row.clientId, challanId: params.row.ChallanAutoID } });
//                         }}
//                     >
//                         {params.value ?? '-'}
//                     </Typography>
//                 </Box>
//             ),
//         },
//         { field: 'RefNo', headerName: 'Ref No.', flex: 1 },
//         {
//             field: 'clientname', headerName: 'Client', flex: 2.5,
//             renderCell: (params) => (
//                 <Box sx={{ cursor: 'pointer', whiteSpace: 'normal', wordBreak: 'break-word', my: 1 }}>
//                     <Typography variant='subtitle2' sx={{ fontSize: '0.85rem' }}>{params.row.FirmName || '-'}</Typography>
//                     <Stack direction='row' alignItems='center' spacing={1}>
//                         <FaUser color='#FF9800' />
//                         <Typography variant='body2'>{params.row.ContactPerson || '-'}</Typography>
//                     </Stack>
//                     <Typography variant='body2' color='text.secondary'>📲 {params.row.MobileNo || '-'}</Typography>
//                 </Box>
//             ),
//         },
//         {
//             field: 'location', headerName: 'Location', flex: 1.5, sortable: true,
//             renderCell: (params) => (
//                 <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                     <Typography variant="body2">{params.row.City || '-'}</Typography>
//                     <Typography variant="caption" color="text.secondary">{params.row.state || '-'}</Typography>
//                 </Box>
//             ),
//         },
//         {
//             field: 'BillAmt', headerName: 'Bill Amount', flex: 1, type: 'number', align: 'right', headerAlign: 'right',
//             valueFormatter: (params) => {
//                 const num = params.value;
//                 if (typeof num !== 'number' || isNaN(num)) return '-';
//                 return `₹${num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
//             },
//         },
//         {
//             field: 'actions', headerName: 'Action', flex: 0.8, align: 'right', headerAlign: 'right', sortable: false,
//             renderCell: (params) => (
//                 <IconButton color="primary" onClick={() => handleView(params.row.ChallanId)}>
//                     <PrintIcon />
//                 </IconButton>
//             ),
//         }
//     ];

//     if (role !== "User") {
//         // add select column at the start
//         challanColumns.unshift({
//             field: 'select', headerName: '', width: 50, sortable: false, disableColumnMenu: true,
//             renderHeader: () => {
//                 const allSelected = challanRows.length > 0 && challanRows.every(row => challanSelectionModel.includes(Number(row.ChallanId)));
//                 const someSelected = challanSelectionModel.length > 0 && !allSelected;

//                 return (
//                     <Checkbox checked={allSelected} indeterminate={someSelected}
//                         onChange={(e) => {
//                             const checked = e.target.checked;
//                             setChallanSelectionModel(checked ? challanRows.map(row => Number(row.ChallanId)) : []);
//                         }}
//                     />
//                 );
//             },
//             renderCell: ({ row }) => {
//                 const rowIdNum = Number(row.ChallanId);
//                 const checked = challanSelectionModel.includes(rowIdNum);

//                 return (
//                     <Checkbox checked={checked}
//                         onChange={(e) => {
//                             const checkedNow = e.target.checked;
//                             setChallanSelectionModel(prev => {
//                                 if (checkedNow) {
//                                     if (!prev.includes(rowIdNum)) {
//                                         return [...prev, rowIdNum];
//                                     }
//                                     return prev;
//                                 } else {
//                                     return prev.filter(id => id !== rowIdNum);
//                                 }
//                             });
//                         }}
//                     />
//                 );
//             },
//         });

//         // add delete column at the end
//         challanColumns.push({
//             field: 'delete', headerName: 'Delete', flex: 0.6, align: 'right', headerAlign: 'right', sortable: false,
//             renderCell: (params) => {
//                 const isSelected = challanSelectionModel.includes(Number(params.row.ChallanId));
//                 return (
//                     <Tooltip title={isSelected ? 'Delete selected challans' : 'Select row to enable delete'} >
//                         <span>
//                             <IconButton color="error" onClick={() => handleChallanDelete(challanSelectionModel)} disabled={!isSelected} size="small" aria-label={isSelected ? 'delete' : 'select-to-enable-delete'} >
//                                 <DeleteIcon />
//                             </IconButton>
//                         </span>
//                     </Tooltip>
//                 );
//             },
//         });
//     }


//     return (
//         <Box sx={{ mx: 'auto', width: '97%', pt: 1 }}>
//             <Box my={1} mx={isMobile ? 2 : 0}>
//                 <Grid container justifyContent='space-between' alignItems='center' mb={1}>
//                     <Box display='flex' alignItems='center' gap={1}>
//                         <IconButton component={Link} to='/main/Purchase-ChallanMaster-stepper' size='small' sx={{ color: 'orange' }} aria-label='New-Order'>
//                             <VscNewFile size={20} />
//                         </IconButton>
//                         <Typography variant='h6' fontWeight={600}>🚚 Purchase Challans Details</Typography>
//                     </Box>
//                     <Box display='flex' alignItems='center' gap={1}>
//                         {selectedRows.length > 0 && (
//                             <Button variant='contained' color='primary' onClick={handleDispatch} sx={{ borderRadius: 2, boxShadow: 4 }}>
//                                 Go To Purchase Dispatch
//                             </Button>
//                         )}
//                         <Button variant='contained' size='small' color='primary' onClick={handleTogglePending}>
//                             {showPending ? 'Hide' : 'Show'}
//                         </Button>
//                     </Box>
//                 </Grid>
//                 <Collapse in={showPending}>
//                     <Box px={isMobile ? 2 : 0} mb={1}>
//                         <Paper sx={{ p: 1, borderRadius: 3 }}>
//                             <Grid container justifyContent='space-between' alignItems='center' mb={2}>
//                                 <Typography variant='h6' fontWeight={600}>📦 My Orders</Typography>
//                             </Grid>
//                             {loadingPending ? (
//                                 <Box textAlign='center' py={4}>
//                                     <CircularProgress />
//                                 </Box>
//                             ) : (
//                                 <DataGrid rows={pendingOrders} columns={columns} getRowId={(row) => String(row.POId)} initialState={{ pagination: { paginationModel: { pageSize: 50, page: 0 } } }} pageSizeOptions={[25, 50, 100]} autoHeight getRowHeight={() => 'auto'}
//                                     sx={{
//                                         '& .MuiDataGrid-columnHeaders': { backgroundColor: themeColors.neutral.gridHeader, borderBottom: `1px solid ${themeColors.neutral.border}` },
//                                         '& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeaderTitle, & .MuiDataGrid-columnHeaderTitleContainer': { color: '#FFFFFF' },
//                                         '& .MuiDataGrid-columnHeader .MuiSvgIcon-root': { color: '#FFFFFF !important', opacity: 1 },
//                                         '& .MuiDataGrid-columnHeader .MuiIconButton-root': { color: '#FFFFFF !important', opacity: 1 },
//                                         '& .MuiDataGrid-columnHeader .MuiDataGrid-menuIcon, & .MuiDataGrid-columnHeader .MuiDataGrid-filterIcon, & .MuiDataGrid-columnHeader .MuiDataGrid-sortIcon': { color: '#FFFFFF !important', opacity: 1 },
//                                         '& .MuiDataGrid-columnHeader .MuiDataGrid-sortIcon svg, & .MuiDataGrid-columnHeader .MuiDataGrid-sortIcon svg path': { fill: '#FFFFFF !important', stroke: '#FFFFFF !important', color: '#FFFFFF !important', opacity: 1 },
//                                         '& .MuiDataGrid-columnHeader .MuiDataGrid-menuIcon svg path, & .MuiDataGrid-columnHeader .MuiDataGrid-filterIcon svg path': { fill: '#FFFFFF !important', stroke: '#FFFFFF !important', opacity: 1 },
//                                         '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: themeColors.neutral.surface },
//                                         '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: themeColors.neutral.surfaceAlt },
//                                         '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': { outline: 'none' },
//                                     }}
//                                 />
//                             )}
//                         </Paper>
//                     </Box>
//                 </Collapse>
//                 {challanLoading ? (
//                     <Box textAlign='center' py={3}>
//                         <CircularProgress />
//                     </Box>
//                 ) : (
//                     <Paper elevation={2} sx={{ borderRadius: 3, p: 2, overflow: 'hidden' }}>
//                         <Box display='flex' justifyContent='space-between' alignItems='center' mb={2}>
//                             <Typography variant='h6' fontWeight={600}>Purchase Challan List</Typography>
//                         </Box>
//                         <DataGrid rows={challanRows} getRowHeight={() => 'auto'} getRowId={(row) => row.ChallanId} autoHeight pageSizeOptions={[25, 50, 100]} columns={challanColumns}
//                             sx={{
//                                 '& .MuiDataGrid-columnHeaders': { backgroundColor: '#165bb5', color: '#FFFFFF', fontWeight: 'bold' },
//                                 '& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeaderTitle, & .MuiDataGrid-columnHeaderTitleContainer': { color: '#FFFFFF' },
//                                 '& .MuiDataGrid-columnHeader .MuiSvgIcon-root': { color: '#FFFFFF !important', opacity: 1 },
//                                 '& .MuiDataGrid-columnHeader .MuiIconButton-root': { color: '#FFFFFF !important', opacity: 1 },
//                                 '& .MuiDataGrid-columnHeader .MuiDataGrid-menuIcon, & .MuiDataGrid-columnHeader .MuiDataGrid-filterIcon, & .MuiDataGrid-columnHeader .MuiDataGrid-sortIcon': { color: '#FFFFFF !important', opacity: 1 },
//                                 '& .MuiDataGrid-columnHeader .MuiDataGrid-sortIcon svg, & .MuiDataGrid-columnHeader .MuiDataGrid-sortIcon svg path': { fill: '#FFFFFF !important', stroke: '#FFFFFF !important', color: '#FFFFFF !important', opacity: 1 },
//                                 '& .MuiDataGrid-columnHeader .MuiDataGrid-menuIcon svg path, & .MuiDataGrid-columnHeader .MuiDataGrid-filterIcon svg path': { fill: '#FFFFFF !important', stroke: '#FFFFFF !important', opacity: 1 },
//                                 '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: themeColors.neutral.surface },
//                                 '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: themeColors.neutral.surfaceAlt },
//                                 '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': { outline: 'none' },
//                             }}
//                         />
//                     </Paper>
//                 )}
//             </Box>
//             <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
//                 <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
//                     {snackbarMessage}
//                 </Alert>
//             </Snackbar>
//             {pdfError && <Alert severity="error" sx={{ mt: 2 }}>PDF Error: {pdfError}</Alert>}
//             {pdfLoading && <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <CircularProgress size={18} /> <Typography>Preparing PDF...</Typography>
//             </Box>}
//             {pdfUri && <Box sx={{ mt: 2 }}><PdfViewer uri={pdfUri} /></Box>}

//             {pdfOverlayVisible && (
//                 <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, bgcolor: 'rgba(0,0,0,0.92)', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//                     <Box sx={{ textAlign: 'center', bgcolor: '#111', p: '40px 60px', borderRadius: 4 }}>
//                         <CircularProgress size={60} thickness={4} sx={{ color: '#fff' }} />
//                         <Typography variant="h6" sx={{ color: '#fff', mt: 3 }}>Generating Purchase Challan PDF…</Typography>
//                         <Typography variant="body2" sx={{ color: '#aaa', mt: 1 }}>Please wait</Typography>
//                     </Box>
//                 </Box>
//             )}
//         </Box>
//     );
// }









import { colors as themeColors, gradients } from '../../utils/theme';
import { useEffect, useMemo, useState, useRef, useCallback } from 'react';
import { Box, Typography, Button, CircularProgress, Paper, Grid, IconButton, Stack, Tooltip, Snackbar, Alert, Checkbox, Collapse, TextField, InputAdornment, Dialog, DialogTitle, DialogContent, DialogActions, Chip, Autocomplete, RadioGroup, Radio, FormControlLabel, Divider, LinearProgress } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import PrintIcon from '@mui/icons-material/Print';
import SearchIcon from '@mui/icons-material/Search';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { FaUser } from 'react-icons/fa';
import { VscNewFile } from 'react-icons/vsc';
import { useMediaQuery, useTheme } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import PdfViewer from '../../components/PdfViewer';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import DescriptionIcon from '@mui/icons-material/Description';
import LinkIcon from '@mui/icons-material/Link';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import PersonIcon from '@mui/icons-material/Person';
import { formatRows } from '../../utils/formatRows';
import NoDataComponent from '../../components/NoDataComponent';
import CustomNoDataOverlay from '../../components/CustomNoDataOverlay';
import CenterLoader from '../../components/CenterLoader';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterListIcon from '@mui/icons-material/FilterList';
import CloseIcon from '@mui/icons-material/Close';
import * as XLSX from 'xlsx';
import LoadingOverlay from '../../components/LoadingOverlay';
import SkeletonLoader from '../../components/SkeletonLoader';
import { motion } from 'framer-motion';

const getFinancialYearRange = (now = new Date()) => {
    const month = now.getMonth();
    const startYear = month >= 3 ? now.getFullYear() : now.getFullYear() - 1;
    const from = `${startYear}-04-01`;
    const to = `${startYear + 1}-03-31`;
    return { from, to };
};

const normalizeDate = (v) => typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v) ? v.split('-').reverse().join('/') : v || '-';

function stringToColor(string) {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    const colors = ['#e74c3c', '#3498db', '#2ecc71', '#e67e22', '#9b59b6', '#1abc9c', '#3f51b5', '#e91e63', '#795548', '#00bcd4'];
    return colors[Math.abs(hash) % colors.length];
}

const formatCurrencyINR = (num) => {
    if (typeof num === "string") num = parseFloat(num);
    if (typeof num !== "number" || isNaN(num)) return "₹0.00";
    return `₹${num.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

const getAvatarColor = (name = "") => {
    const colors = ["#e74c3c", "#3498db", "#2ecc71", "#e67e22", "#9b59b6", "#1abc9c", "#3f51b5", "#e91e63", "#795548", "#00bcd4"];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % colors.length;
    return colors[index];
};

function getInitials(name) {
    if (!name) return 'C';
    return name.trim().charAt(0).toUpperCase();
}

export default function PurcDispatchDetails({ connectionString, pdfString }) {
    const { user, selectedCompany } = useAuth();
    const userId = user?.UserId || null;
    const companyId = selectedCompany?.CompId || null;
    const API_URL = `${connectionString}/api`;

    const role = user?.UserCategory || null;
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showPending, setShowPending] = useState(false);
    const [pendingOrders, setPendingOrders] = useState([]);
    const [loadingPending, setLoadingPending] = useState(false);
    const [pendingFetched, setPendingFetched] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedRowIds, setSelectedRowIds] = useState([]);
    const [challanRows, setChallanRows] = useState([]);
    const [challanLoading, setChallanLoading] = useState(true);
    const [challanSelectionModel, setChallanSelectionModel] = useState([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const [filterPopupOpen, setFilterPopupOpen] = useState(false);
    const [filterPopupMode, setFilterPopupMode] = useState('datewise');
    const [filterPopupFromDate, setFilterPopupFromDate] = useState('');
    const [filterPopupToDate, setFilterPopupToDate] = useState('');
    const [filterPopupFirms, setFilterPopupFirms] = useState([]);
    const [firmOptions, setFirmOptions] = useState([]);
    const [firmAllOptions, setFirmAllOptions] = useState([]);
    const [firmInputValue, setFirmInputValue] = useState('');
    const [firmLoading, setFirmLoading] = useState(false);
    const [filterPopupSnapshot, setFilterPopupSnapshot] = useState(null);
    const [pdfOverlayVisible, setPdfOverlayVisible] = useState(false);
    const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
    const [pdfUri, setPdfUri] = useState(null);
    const [pdfLoading, setPdfLoading] = useState(false);
    const [pdfError, setPdfError] = useState(null);
    const newWinRef = useRef(null);
    const revokeIntervalRef = useRef(null);
    const [openChallanDeleteDialog, setOpenChallanDeleteDialog] = useState(false);
    const [pendingChallanDeleteIds, setPendingChallanDeleteIds] = useState([]);
    const [deleting, setDeleting] = useState(false);
    const [exportExcelEnabled, setExportExcelEnabled] = useState(false);
    const [masterReportData, setMasterReportData] = useState([]);
    const [detailsReportData, setDetailsReportData] = useState([]);
    const [reportLoading, setReportLoading] = useState(false);


    // Search state for small screens
    const [searchQuery, setSearchQuery] = useState('');

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md')); // small + mobile
    const isSmallDevice = useMediaQuery(theme.breakpoints.down(500));
    const navigate = useNavigate();
    const params = { userId, userCategory: role, companyId };

    useEffect(() => {
        (async () => {
            setLoading(true);
            try {
                const res = await axios.get(`${API_URL}/Purchaseorders`, { params: { ...params, mode: "ref", }, headers: { 'Cache-Control': 'no-store' } });
                const raw = Array.isArray(res.data) ? res.data : [];
                const rows = raw.map(r => {
                    const soId = r.SOId ?? r.SOAutoID ?? r.id ?? r.POId;
                    return { ...r, id: String(r.POId), SOId: Number(r.POId), SOAutoID: Number(soId), BillAmt: Number(r.BillAmt) || 0, clientId: Number(r.PartyID), };
                });
                setOrders(formatRows(rows));
                setPendingOrders(formatRows(rows));
            } catch (err) {
                console.error('❌ Failed to fetch orders', err);
                setOrders([]);
                setPendingOrders([]);
            } finally {
                setLoading(false);
                setLoadingPending(false);
            }
        })();
    }, []);

    useEffect(() => {
        return () => {
            if (revokeIntervalRef.current) clearInterval(revokeIntervalRef.current);
            if (pdfUri) URL.revokeObjectURL(pdfUri);
            if (newWinRef.current && !newWinRef.current.closed) newWinRef.current.close();
        };
    }, [pdfUri]);

    useEffect(() => {
        (async function fetchChallans() {
            try {
                const res = await axios.get(`${API_URL}/Purchase-dispatch`, { params, headers: { 'Cache-Control': 'no-store' } });
                const data = Array.isArray(res.data) ? res.data : [];
                const rows = data.map((row, idx) => ({
                    id: row.ChallanId ?? idx,
                    ChallanId: row.ChallanId ?? idx,
                    ChallanAutoID: row.ChallanId ?? idx,
                    ChallanNumber: row.ChallanNumber,
                    RefNo: row.RefNo,
                    ChallanDate: row.ChallanDate ? new Date(row.ChallanDate).toLocaleDateString('en-GB') : '',
                    clientname: [row.FirmName, row.ContactPerson, row.MobileNo,].filter(Boolean).join(' '),
                    FirmName: row.FirmName,
                    ContactPerson: row.ContactPerson,
                    MobileNo: row.MobileNo,
                    City: row.City,
                    state: row.state,
                    BillAmt: Number(row.BillAmt) || 0,
                    PartyID: row.PartyID,
                    clientId: row.PartyID,
                }));
                setChallanRows(formatRows(rows));
            } catch (err) {
                console.error('Error fetching challans:', err);
            } finally {
                setChallanLoading(false);
            }
        })();
    }, []);

    const handleTogglePending = () => {
        setShowPending(prev => !prev);
        setSearchQuery('');
    };

    const handleDispatch = () => {
        if (selectedRows.length === 0) return;

        const firstOrder = selectedRows[0];
        const selectedPOIds = selectedRows.map(r => r.POId);

        const clientId = firstOrder.clientId ?? firstOrder.PartyID ?? firstOrder.partyIdRaw ?? null;

        if (!clientId) {
            setSnackbarMessage('Selected order does not have a clientId — cannot proceed.');
            setSnackbarSeverity('warning');
            setSnackbarOpen(true);
            return;
        }
        navigate(`/main/Purchase-ChallanMaster-stepper-ref/${clientId}`, { state: { selectedPOIds } });
    };

    // const handleView = async (challanId) => {
    //     if (isGeneratingPdf || !challanId) return;

    //     setPdfOverlayVisible(true);
    //     setIsGeneratingPdf(true);
    //     setPdfError(null);
    //     setPdfUri(null);

    //     const userIdSafe = userId || 'usr1';

    //     let formatId = 'format_1';
    //     let bookNameToSend = 'PurchaseDispatch';
    //     let bookIdToSend = null;

    //     try {
    //         const found = challanRows.find(r => Number(r.ChallanId) === Number(challanId));
    //         if (found?.BookName) bookNameToSend = String(found.BookName).trim();
    //         else if (found?.bookName) bookNameToSend = String(found.bookName).trim();
    //     } catch (e) { }

    //     try {
    //         const resp = await axios.get(`${API_URL}/companies`, { params: { companyId } });
    //         const comps = Array.isArray(resp?.data?.companies) ? resp.data.companies :
    //             Array.isArray(resp?.data) ? resp.data : [resp.data].filter(Boolean);

    //         const eq = (a, b) => String(a ?? '').trim().toLowerCase() === String(b ?? '').trim().toLowerCase();
    //         let matched = null;

    //         for (const c of comps) {
    //             if (Array.isArray(c.formats)) {
    //                 for (const f of c.formats) {
    //                     if (eq(f.BookName || f.bookName, bookNameToSend) ||
    //                         eq(f.FormName || f.formName, "PurchaseDispatch") ||
    //                         String(f.FormName || '').toLowerCase().includes('purchasedispatch')) {
    //                         matched = f;
    //                         break;
    //                     }
    //                 }
    //                 if (matched) break;
    //             }
    //             if (eq(c.BookName || c.bookName, bookNameToSend)) { matched = c; break; }
    //         }

    //         if (matched) {
    //             const id = matched.BookID ?? matched.BookId ?? matched.bookId;
    //             if (id) { formatId = `format_${id}`; bookIdToSend = id; }
    //             else if (matched.FormName || matched.formName) formatId = String(matched.FormName || matched.formName);
    //             bookNameToSend = matched.BookName || matched.bookName || bookNameToSend;
    //         }
    //     } catch (err) {
    //         console.warn("Format detection failed → using defaults");
    //     }

    //     try {
    //         setPdfLoading(true);

    //         const { data } = await axios.get(`${API_URL}/get-purdispatch-data/${challanId}`, {
    //             params: { companyId },
    //             headers: { 'Cache-Control': 'no-store' }
    //         });

    //         console.log(data);

    //         const { master, items = [], details, company } = data || {};
    //         if (!master) throw new Error("No master data returned");

    //         let imageBase64 = null;
    //         try {
    //             const iconRes = await axios.get(`${API_URL}/company/GetIcon/${companyId}`);
    //             if (iconRes?.data?.success && iconRes?.data?.imageBase64) {
    //                 imageBase64 = iconRes.data.imageBase64.replace(/^data:image\/\w+;base64,/, '');
    //             }
    //         } catch (e) { /* ignore */ }

    //         const transformedItems = (items.length ? items : details || []).map(d => ({
    //             ItemCode: d.itemCode || "",
    //             productImage: d.productImage || "",
    //             hsnCode: d.HSN || "",
    //             Remark: d.Remark || "",
    //             description: d.description || d.productDescription || "",
    //             qty: Number(d.Qty) || 0,
    //             unit: d.UnitValue || "",
    //             rate: Number(d.Rate) || 0,
    //             discount: Number(d.Disc) || 0,
    //             cgst: Number(d.CGST) || 0,
    //             sgst: Number(d.SGST) || 0,
    //             igst: Number(d.IGST) || 0,
    //             amount: Number(d.ItemTotal) || 0,
    //         }));

    //         const pdfData = {
    //             companyId,
    //             companyName: master?.clientDetails?.clientname || master?.FirmName || master?.PartyName || "",
    //             address: master?.clientDetails?.address || master?.Address || "",
    //             phone: master?.clientDetails?.mobileNo || master?.MobileNo || "",
    //             gstNo: master?.clientDetails?.gstno || master?.GSTNo || "",
    //             invoiceNo: master?.ChallanNumber || "",
    //             referrenceNo: master?.PartyPONO || master?.RefNo || "",
    //             date: master?.ChallanDate ? normalizeDate(master.ChallanDate) : "",
    //             transport: "SELF",
    //             challanNo: master?.ChallanNumber || "",
    //             poNo: master?.PartyPONO || "",
    //             state: master?.clientDetails?.state || master?.state || "",
    //             stateCode: master?.clientDetails?.stateCode || master?.StateCode || "",
    //             LrNo: master?.LRNo || "",
    //             vehNo: master?.VehicleNo || "",
    //             LrDate: master?.DeliveryDate ? normalizeDate(master.DeliveryDate) : "",
    //             shipToGstNumber: master?.clientDetails?.gstno || "",
    //             shipToState: master?.clientDetails?.state || "",
    //             items: transformedItems,
    //             toEmail: master?.clientDetails?.emailId || "",
    //             totalAmount: Number(master?.BillAmt) || 0,
    //             mobileNo: master?.clientDetails?.mobileNo || "",
    //             BasicAmt: Number(master?.BasicAmt) || 0,
    //             CGSTAmt: Number(master?.CGSTAmt) || 0,
    //             SGSTAmt: Number(master?.SGSTAmt) || 0,
    //             IGSTAmt: Number(master?.IGSTAmt) || 0,
    //             RoundOff: Number(master?.RoundOff) || 0,
    //             BillAmt: Number(master?.BillAmt) || 0,
    //             clientState: master?.clientState || "",
    //             imageBase64: imageBase64 || null,
    //             Remark: master.Remark || null
    //         };

    //         const companyHeader = company ? {
    //             CompId: company.CompId,
    //             CompanyName: company.CompanyName || "",
    //             Address: company.Address || "",
    //             MobileNo: company.MobileNo || "",
    //             EmailId: company.EmailId || "",
    //             Website: company.Website || "",
    //             GSTNo: company.GSTNo || "",
    //             imageBase64: imageBase64 || null,
    //             city: company.City || null,
    //             BkName1: company.BkName1 || null,
    //             BkBranch1: company.BkBranch1 || null,
    //             BkAcNo1: company.BkAcNo1 || null,
    //             BkIFSCCode1: company.BkIFSCCode1 || null,
    //         } : null;

    //         const pdfResp = await axios.post(
    //             `${pdfString}/api/pdf/PurchaseDispatch/${challanId}`,
    //             {
    //                 docId: challanId,
    //                 userId: userIdSafe,
    //                 formatId,
    //                 data: pdfData,
    //                 company: companyHeader
    //             },
    //             { responseType: "blob", timeout: 120000 }
    //         );

    //         const blob = pdfResp.data;
    //         if (!blob || blob.size === 0) throw new Error("Empty PDF");

    //         const blobUrl = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));

    //         // (old code : commented to implement pdf view in webview)
    //         // const newWin = window.open("", "_blank");
    //         // if (newWin) {
    //         //     newWinRef.current = newWin;
    //         //     newWin.location.href = blobUrl;
    //         //     newWin.focus();

    //         //     const checker = setInterval(() => {
    //         //         if (newWin.closed) {
    //         //             URL.revokeObjectURL(blobUrl);
    //         //             clearInterval(checker);
    //         //             newWinRef.current = null;
    //         //         }
    //         //     }, 1000);
    //         //     revokeIntervalRef.current = checker;
    //         // } else {
    //         //     if (pdfUri) URL.revokeObjectURL(pdfUri);
    //         //     setPdfUri(blobUrl);
    //         //     setSnackbarMessage("Popup blocked — showing inline");
    //         //     setSnackbarSeverity("warning");
    //         //     setSnackbarOpen(true);
    //         // }


    //         // (new code : Added to handle pdf in web and mobile both using webview)
    //         if (window.ReactNativeWebView) {

    //             const reader = new FileReader();

    //             reader.onloadend = () => {
    //                 window.ReactNativeWebView.postMessage(
    //                     JSON.stringify({
    //                         type: "OPEN_PDF",
    //                         base64: reader.result
    //                     })
    //                 );
    //             };

    //             reader.readAsDataURL(blob);

    //         } else {

    //             const newWin = window.open("", "_blank");
    //             if (newWin) {
    //                 newWinRef.current = newWin;
    //                 newWin.location.href = blobUrl;
    //                 newWin.focus();

    //                 const checker = setInterval(() => {
    //                     if (newWin.closed) {
    //                         URL.revokeObjectURL(blobUrl);
    //                         clearInterval(checker);
    //                         newWinRef.current = null;
    //                     }
    //                 }, 1000);
    //                 revokeIntervalRef.current = checker;
    //             } else {
    //                 if (pdfUri) URL.revokeObjectURL(pdfUri);
    //                 setPdfUri(blobUrl);
    //                 setSnackbarMessage("Popup blocked — showing inline");
    //                 setSnackbarSeverity("warning");
    //                 setSnackbarOpen(true);
    //             }
    //         }

    //     } catch (err) {
    //         console.error("Purchase Challan PDF error:", err);
    //         setPdfError("Failed to generate PDF");
    //         setSnackbarMessage("Could not load PDF. Please try again.");
    //         setSnackbarSeverity("error");
    //         setSnackbarOpen(true);
    //     } finally {
    //         setPdfOverlayVisible(false);
    //         setIsGeneratingPdf(false);
    //         setPdfLoading(false);
    //     }
    // };

    const handleView = async (challanId) => {
        if (isGeneratingPdf || !challanId) return;

        setPdfOverlayVisible(true);
        setIsGeneratingPdf(true);
        setPdfError(null);
        setPdfUri(null);

        const userIdSafe = userId || 'usr1';

        let formatId = 'format_1';
        let bookNameToSend = 'PurchaseDispatch';
        let bookIdToSend = null;
        let pageSize = 'A5'; // ✅ NEW: Default to A5

        try {
            const found = challanRows.find(r => Number(r.ChallanId) === Number(challanId));
            if (found?.BookName) bookNameToSend = String(found.BookName).trim();
            else if (found?.bookName) bookNameToSend = String(found.bookName).trim();
        } catch (e) { }

        let matchedFormat = null;
        try {
            // ✅ Add cache-buster to get fresh data
            const cacheBreaker = new Date().getTime();
            const resp = await axios.get(`${API_URL}/companies`, { params: { companyId, t: cacheBreaker } });
            const comps = Array.isArray(resp?.data?.companies) ? resp.data.companies :
                Array.isArray(resp?.data) ? resp.data : [resp.data].filter(Boolean);

            const eq = (a, b) => String(a ?? '').trim().toLowerCase() === String(b ?? '').trim().toLowerCase();
            let matched = null;

            for (const c of comps) {
                if (Array.isArray(c.formats)) {
                    for (const f of c.formats) {
                        if (eq(f.BookName || f.bookName, bookNameToSend) ||
                            eq(f.FormName || f.formName, "PurchaseDispatch") ||
                            String(f.FormName || '').toLowerCase().includes('purchasedispatch')) {
                            matched = f;
                            break;
                        }
                    }
                    if (matched) break;
                }
                if (eq(c.BookName || c.bookName, bookNameToSend)) { matched = c; break; }
            }

            if (matched) {
                const id = matched.BookID ?? matched.BookId ?? matched.bookId;
                if (id) { formatId = `format_${id}`; bookIdToSend = id; }
                else if (matched.FormName || matched.formName) formatId = String(matched.FormName || matched.formName);
                bookNameToSend = matched.BookName || matched.bookName || bookNameToSend;

                // ✅ NEW: Extract PageSize from matched format (default A5 if not present)
                if (matched.PageSize) {
                    pageSize = matched.PageSize === 'A4' ? 'A4' : 'A5';
                }
                // ✅ Store matched format for Signature checking (fresh from API)
                matchedFormat = matched;
            }
        } catch (err) {
            console.warn("Format detection failed → using defaults");
        }

        try {
            setPdfLoading(true);

            const { data } = await axios.get(`${API_URL}/get-purdispatch-data/${challanId}`, {
                params: { companyId },
                headers: { 'Cache-Control': 'no-store' }
            });

            console.log(data);

            const { master, items = [], details, company, termsAndConditions, additionalChargeItems } = data || {};
            if (!master) throw new Error("No master data returned");
            const termsText = Array.isArray(termsAndConditions) && termsAndConditions.length > 0
                ? termsAndConditions
                    .sort((a, b) => a.SrNo - b.SrNo)
                    .map(t => `# ${t.TermsDescription}`)
                    .join('\n')
                : null;

            let imageBase64 = null;
            let signatureBase64 = null;
            try {
                const iconRes = await axios.get(`${API_URL}/company/GetIcon/${companyId}`);
                if (iconRes?.data?.success && iconRes?.data?.imageBase64) {
                    imageBase64 = iconRes.data.imageBase64.replace(/^data:image\/\w+;base64,/, '');
                }
                if (iconRes?.data?.signatureBase64) {
                    signatureBase64 = iconRes.data.signatureBase64;
                }
            } catch (e) { /* ignore */ }
            // ✅ Use matched format's Signature (fresh from API, not cached context)
            if (!matchedFormat?.Signature) signatureBase64 = null;

            const transformedItems = (items.length ? items : details || []).map(d => ({
                ItemCode: d.itemCode || "",
                productImage: d.productImage || "",
                hsnCode: d.HSN || "",
                Remark: d.Remark || "",
                description: d.description || d.productDescription || "",
                qty: Number(d.Qty) || 0,
                unit: d.UnitValue || "",
                rate: Number(d.Rate) || 0,
                discount: Number(d.Disc) || 0,
                cgst: Number(d.CGST) || 0,
                sgst: Number(d.SGST) || 0,
                igst: Number(d.IGST) || 0,
                amount: Number(d.ItemTotal) || 0,
                TaxableAmt: Number(d.TaxableAmt) || 0,
            }));

            // ✅ NEW: Additional Charges
            const additionalCharges = [1, 2, 3, 4, 5]
                .map(slot => {
                    const chargeItem = (additionalChargeItems || []).find(ci => Number(ci.TransType) === 199 + slot);
                    return {
                        name: chargeItem?.description || `Charge ${slot}`,
                        amount: Number(master[`Adc${slot}Amt`]) || 0,
                    };
                })
                .filter(c => c.amount > 0);

            const pdfData = {
                companyId,
                companyName: master?.clientDetails?.clientname || master?.FirmName || master?.PartyName || "",
                address: master?.clientDetails?.address || master?.Address || "",
                phone: master?.clientDetails?.mobileNo || master?.MobileNo || "",
                gstNo: master?.clientDetails?.gstno || master?.GSTNo || "",
                invoiceNo: master?.ChallanNumber || "",
                referrenceNo: master?.PartyPONO || master?.RefNo || "",
                date: master?.ChallanDate ? normalizeDate(master.ChallanDate) : "",
                transport: "SELF",
                challanNo: master?.ChallanNumber || "",
                poNo: master?.PartyPONO || "",
                state: master?.clientDetails?.state || master?.state || "",
                stateCode: master?.clientDetails?.stateCode || master?.StateCode || "",
                LrNo: master?.LRNo || "",
                vehNo: master?.VehicleNo || "",
                LrDate: master?.DeliveryDate ? normalizeDate(master.DeliveryDate) : "",
                shipToGstNumber: master?.clientDetails?.gstno || "",
                shipToState: master?.clientDetails?.state || "",
                items: transformedItems,
                toEmail: master?.clientDetails?.emailId || "",
                totalAmount: Number(master?.BillAmt) || 0,
                mobileNo: master?.clientDetails?.mobileNo || "",
                BasicAmt: Number(master?.TaxableAmt) || 0,
                additionalCharges,
                CGSTAmt: Number(master?.CGSTAmt) || 0,
                SGSTAmt: Number(master?.SGSTAmt) || 0,
                IGSTAmt: Number(master?.IGSTAmt) || 0,
                RoundOff: Number(master?.RoundOff) || 0,
                BillAmt: Number(master?.BillAmt) || 0,
                clientState: master?.clientState || "",
                imageBase64: imageBase64 || null,
                Remark: master.Remark || null,
                termsAndConditions: termsText,
                PaymentTerm: master?.PaymentTerm || null,
            };

            const companyHeader = company ? {
                CompId: company.CompId,
                CompanyName: company.CompanyName || "",
                Address: company.Address || "",
                MobileNo: company.MobileNo || "",
                EmailId: company.EmailId || "",
                Website: company.Website || "",
                GSTNo: company.GSTNo || "",
                imageBase64: imageBase64 || null,
                signatureBase64: signatureBase64 || null,
                city: company.City || null,
                BkName1: company.BkName1 || null,
                BkBranch1: company.BkBranch1 || null,
                BkAcNo1: company.BkAcNo1 || null,
                BkIFSCCode1: company.BkIFSCCode1 || null,
                // ✅ NEW: Include Color from matchedFormat for PDF rendering
                headerColor: matchedFormat?.Color || themeColors.neutral.black,
            } : null;

            console.log('📄 [Purchase Dispatch PDF] pdfData.additionalCharges:', pdfData.additionalCharges);
            console.log('📄 [Purchase Dispatch PDF] Full pdfData:', pdfData);

            const pdfResp = await axios.post(
                `${pdfString}/api/pdf/PurchaseDispatch/${challanId}`,
                {
                    docId: challanId,
                    userId: userIdSafe,
                    formatId,
                    data: pdfData,
                    company: companyHeader,
                    pageSize: pageSize // ✅ NEW: Send PageSize to backend
                },
                { responseType: "blob", timeout: 120000 }
            );

            const blob = pdfResp.data;
            if (!blob || blob.size === 0) throw new Error("Empty PDF");

            const blobUrl = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));

            // (new code : Added to handle pdf in web and mobile both using webview)
            if (window.ReactNativeWebView) {

                const reader = new FileReader();

                reader.onloadend = () => {
                    window.ReactNativeWebView.postMessage(
                        JSON.stringify({
                            type: "OPEN_PDF",
                            base64: reader.result
                        })
                    );
                };

                reader.readAsDataURL(blob);

            } else {

                const newWin = window.open("", "_blank");
                if (newWin) {
                    newWinRef.current = newWin;
                    newWin.location.href = blobUrl;
                    newWin.focus();

                    const checker = setInterval(() => {
                        if (newWin.closed) {
                            URL.revokeObjectURL(blobUrl);
                            clearInterval(checker);
                            newWinRef.current = null;
                        }
                    }, 1000);
                    revokeIntervalRef.current = checker;
                } else {
                    if (pdfUri) URL.revokeObjectURL(pdfUri);
                    setPdfUri(blobUrl);
                    setSnackbarMessage("Popup blocked — showing inline");
                    setSnackbarSeverity("warning");
                    setSnackbarOpen(true);
                }
            }

        } catch (err) {
            console.error("Purchase Challan PDF error:", err);
            setPdfError("Failed to generate PDF");
            setSnackbarMessage("Could not load PDF. Please try again.");
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        } finally {
            setPdfOverlayVisible(false);
            setIsGeneratingPdf(false);
            setPdfLoading(false);
        }
    };

    const handleChallanDelete = (objAryId) => {
        if (!objAryId || objAryId.length === 0) {
            setSnackbarMessage("No challans selected for deletion.");
            setSnackbarSeverity("warning");
            setSnackbarOpen(true);
            return;
        }

        const numericIds = objAryId.map(Number).filter(n => !isNaN(n));
        if (!numericIds.length) return;

        setPendingChallanDeleteIds(numericIds);
        setOpenChallanDeleteDialog(true);
    };


    // const confirmChallanDelete = async () => {
    //     const numericIds = pendingChallanDeleteIds;
    //     if (!numericIds.length) return;

    //     setOpenChallanDeleteDialog(false);
    //     try {
    //         const payload = { objAryId: numericIds, companyId };
    //         const { data } = await axios.post(`${API_URL}/delete-PurchaseDispatch`, payload);
    //         const deletedIds = data.deletedIds || [];
    //         const totalDeleted = (data.deletedChallanDetails || 0) + (data.deletedChallans || 0);
    //         if (totalDeleted > 0) {
    //             setChallanRows(prev =>
    //                 prev.filter(
    //                     row => !deletedIds.includes(Number(row.ChallanAutoID))
    //                 )
    //             );

    //             setChallanSelectionModel(prev =>
    //                 prev.filter(
    //                     id => !deletedIds.includes(Number(id))
    //                 )
    //             );
    //             setSnackbarMessage(`Deleted successfully.`);
    //             setSnackbarSeverity('success');
    //         } else if (data.referencedIds && data.referencedIds.length > 0) {
    //             setSnackbarMessage(data.message);
    //             setSnackbarSeverity('warning');
    //         } else {
    //             setSnackbarMessage('No challans were deleted, references exist.');
    //             setSnackbarSeverity('warning');
    //         }
    //         setSnackbarOpen(true);
    //     } catch (err) {
    //         console.error('Error deleting challans:', err);
    //         setSnackbarMessage(`Failed to delete one or more challans: ${err.response?.data?.message || err.message}`);
    //         setSnackbarSeverity('error');
    //         setSnackbarOpen(true);
    //     } finally {
    //         setPendingChallanDeleteIds([]);
    //     }
    // };

    const confirmChallanDelete = async () => {
        const numericIds = pendingChallanDeleteIds;
        if (!numericIds.length || deleting) return;

        setDeleting(true);

        try {
            const payload = { objAryId: numericIds, companyId };
            const { data } = await axios.post(
                `${API_URL}/delete-PurchaseDispatch`,
                payload
            );

            const deletedIds = data.deletedIds || [];
            const referencedIds = data.referencedIds || [];

            // ✅ REMOVE ONLY ACTUALLY DELETED ROWS
            if (deletedIds.length > 0) {
                setChallanRows(prev =>
                    prev.filter(
                        row => !deletedIds.includes(Number(row.ChallanAutoID))
                    )
                );

                setChallanSelectionModel(prev =>
                    prev.filter(
                        id => !deletedIds.includes(Number(id))
                    )
                );
            }

            // ✅ BUILD CORRECT MESSAGE

            if (deletedIds.length > 0) {
                setSnackbarMessage("Deleted Successfully.");
                setSnackbarSeverity("success");
                setSnackbarOpen(true);
            }

            if (referencedIds.length > 0 && deletedIds.length <= 0) {
                setSnackbarMessage("Cannot delete the selected item(s) because they are referenced in other records.");
                setSnackbarSeverity("warning");
                setSnackbarOpen(true);
            }

        } catch (err) {
            console.error('Error deleting challans:', err);
            setSnackbarMessage(
                err.response?.data?.message || 'Failed to delete challans'
            );
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
        } finally {
            setDeleting(false);
            setOpenChallanDeleteDialog(false);
            setPendingChallanDeleteIds([]);
        }
    };

    const openFilterPopup = useCallback(() => {
        const { from, to } = getFinancialYearRange(new Date());
        const fromDate = filterPopupFromDate || from;
        const toDate = filterPopupToDate || to;
        if (!filterPopupFromDate) setFilterPopupFromDate(fromDate);
        if (!filterPopupToDate) setFilterPopupToDate(toDate);
        setFilterPopupSnapshot({ mode: filterPopupMode, fromDate, toDate, firms: filterPopupFirms });
        setFilterPopupOpen(true);
    }, [filterPopupFromDate, filterPopupToDate, filterPopupMode, filterPopupFirms]);

    const cancelFilterPopup = useCallback(() => {
        if (filterPopupSnapshot) {
            setFilterPopupMode(filterPopupSnapshot.mode);
            setFilterPopupFromDate(filterPopupSnapshot.fromDate);
            setFilterPopupToDate(filterPopupSnapshot.toDate);
            setFilterPopupFirms(filterPopupSnapshot.firms || []);
        }
        setFilterPopupOpen(false);
    }, [filterPopupSnapshot]);

    const handleFilterOk = useCallback(async () => {
        setExportExcelEnabled(true);

        if (!companyId) {
            setSnackbarMessage('Company not selected');
            setSnackbarSeverity('warning');
            setSnackbarOpen(true);
            return;
        }

        if (!filterPopupFromDate || !filterPopupToDate) {
            setSnackbarMessage('Please select date range');
            setSnackbarSeverity('warning');
            setSnackbarOpen(true);
            return;
        }

        setReportLoading(true);

        try {
            const filterParams = {
                companyId,
                fromDate: filterPopupFromDate,
                toDate: filterPopupToDate,
                mode: filterPopupMode,
                firms: filterPopupFirms.length > 0
                    ? filterPopupFirms.map(f => f.id).join(',')
                    : '',
            };

            const response = await axios.get(
                `${API_URL}/purchase-challan-register`,
                { params: filterParams }
            );

            const masterData = response?.data?.master?.data || [];
            const detailsData = response?.data?.details?.data || [];

            setMasterReportData(masterData);
            setDetailsReportData(detailsData);

            setSnackbarMessage(`Report loaded: ${masterData.length} master records, ${detailsData.length} detail records`);
            setSnackbarSeverity('success');
            setSnackbarOpen(true);

            console.log('Master Report Data:', masterData);
            console.log('Details Report Data:', detailsData);

        } catch (err) {
            console.error('Error fetching report data:', err);
            setSnackbarMessage(err?.response?.data?.message || 'Failed to fetch report data');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
        } finally {
            setReportLoading(false);
        }
    }, [
        companyId,
        filterPopupFromDate,
        filterPopupToDate,
        filterPopupMode,
        filterPopupFirms,
        API_URL
    ]);

    const handleExportExcel = useCallback(() => {
        if (!masterReportData.length && !detailsReportData.length) {
            setSnackbarMessage('No data to export. Please apply filters first.');
            setSnackbarSeverity('warning');
            setSnackbarOpen(true);
            return;
        }

        const formatDate = (val) => {
            if (!val) return '';
            const s = String(val).split('T')[0];
            if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
                const [y, m, d] = s.split('-');
                return `${d}-${m}-${y}`;
            }
            return val;
        };

        const buildSheet = (data, columns) => {
            const header = columns.map(c => c.header);
            const rows = data.map(row =>
                columns.map(c => {
                    const val = row[c.key] ?? '';
                    if (c.isDate) return formatDate(val);
                    if (val === 0 || val === '0' || val === 0.0) return '';
                    // Numeric columns often arrive from the API as strings (e.g. SQL
                    // DECIMAL fields serialized as text). aoa_to_sheet writes cells
                    // based on the JS value's type, so a string here becomes a text
                    // cell that Excel's status bar (Sum/Average) will not aggregate.
                    // Coerce to a real number so these columns total correctly.
                    if (c.isNumeric) {
                        const num = Number(val);
                        return Number.isNaN(num) ? val : num;
                    }
                    return val;
                })
            );
            return XLSX.utils.aoa_to_sheet([header, ...rows]);
        };

        // ✅ TransactionType REMOVED from masterColumns
        const masterColumns = [
            { key: 'ChallanDate', header: 'BillDate', isDate: true },
            { key: 'ChallanNumber', header: 'BillNumber' },
            { key: 'FirmName', header: 'FirmName' },
            { key: 'GSTNo', header: 'GSTNo' },
            { key: 'state', header: 'State' },
            { key: 'StateCode', header: 'StateCode' },
            { key: 'TransactionType', header: 'TransactionType' },
            { key: 'GSTRate', header: 'GSTRate', isNumeric: true },
            { key: 'TaxableAmt', header: 'TaxableAmt', isNumeric: true },
            { key: 'CGSTAmt', header: 'CGSTAmt', isNumeric: true },
            { key: 'SGSTAmt', header: 'SGSTAmt', isNumeric: true },
            { key: 'IGSTAmt', header: 'IGSTAmt', isNumeric: true },
            { key: 'UTGSTAmt', header: 'UTGSTAmt', isNumeric: true },
            { key: 'GSTCEssAmt', header: 'GSTCessAmt', isNumeric: true },
            { key: 'BillAmt', header: 'BillAmt', isNumeric: true },
            { key: 'Remark', header: 'Remark' },
        ];

        // ✅ TransactionType REMOVED from detailsColumns
        const detailsColumns = [
            { key: 'ChallanDate', header: 'BillDate', isDate: true },
            { key: 'ChallanNumber', header: 'BillNumber' },
            { key: 'FirmName', header: 'FirmName' },
            { key: 'GSTNo', header: 'GSTNo' },
            { key: 'state', header: 'State' },
            { key: 'StateCode', header: 'StateCode' },
            { key: 'TransactionType', header: 'TransactionType' },
            { key: 'itemCode', header: 'ItemCode' },
            { key: 'description', header: 'Description' },
            { key: 'HSNNo', header: 'HSNNo' },
            { key: 'Unit', header: 'Unit' },
            { key: 'QTY', header: 'Qty', isNumeric: true },
            { key: 'Rate', header: 'Rate', isNumeric: true },
            { key: 'Disc', header: 'Disc', isNumeric: true },
            { key: 'TaxableAmt', header: 'TaxableAmt', isNumeric: true },
            { key: 'GSTRate', header: 'GSTRate', isNumeric: true },
            { key: 'CGSTRate', header: 'CGSTRate', isNumeric: true },
            { key: 'SGSTRate', header: 'SGSTRate', isNumeric: true },
            { key: 'IGSTRate', header: 'IGSTRate', isNumeric: true },
            { key: 'CESSRate', header: 'CESSRate', isNumeric: true },
            { key: 'UTGSTRate', header: 'UTGSTRate', isNumeric: true },
            { key: 'CGSTAmt', header: 'CGSTAmt', isNumeric: true },
            { key: 'SGSTAmt', header: 'SGSTAmt', isNumeric: true },
            { key: 'IGSTAmt', header: 'IGSTAmt', isNumeric: true },
            { key: 'CESSAmt', header: 'CESSAmt', isNumeric: true },
            { key: 'UTGSTAmt', header: 'UTGSTAmt', isNumeric: true },
            { key: 'ItemRemark', header: 'ItemRemark' },
        ];

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, buildSheet(masterReportData, masterColumns), 'Master');
        XLSX.utils.book_append_sheet(wb, buildSheet(detailsReportData, detailsColumns), 'Details');

        const fromDate = filterPopupFromDate || 'start';
        const toDate = filterPopupToDate || 'end';
        XLSX.writeFile(wb, `PurchaseChallanRegister_${fromDate}_${toDate}.xlsx`);

        setSnackbarMessage('Excel exported successfully!');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
    }, [masterReportData, detailsReportData, filterPopupFromDate, filterPopupToDate]);

    useEffect(() => {
        if (!filterPopupOpen) return;
        if (!API_URL || !companyId) return;
        let active = true;
        const fetchAllFirms = async () => {
            try {
                setFirmLoading(true);
                const res = await axios.get(`${API_URL}/company-search`, { params: { field: 'FirmName', search: '', companyId, limit: 1000 } });
                const data = Array.isArray(res?.data?.data) ? res.data.data : [];
                if (!active) return;
                const opts = data.map(r => ({ id: r?.id, label: r?.FirmName || '' })).filter(o => o.label);
                setFirmAllOptions(opts);
                if (!(firmInputValue || '').trim()) setFirmOptions(opts);
            } catch (err) {
                if (!active) return;
                setFirmAllOptions([]);
                setFirmOptions([]);
            } finally {
                if (active) setFirmLoading(false);
            }
        };
        fetchAllFirms();
        return () => { active = false; };
    }, [companyId, API_URL, filterPopupOpen]);

    useEffect(() => {
        if (!(firmInputValue || '').trim()) {
            setFirmOptions(firmAllOptions);
            return;
        }
        const q = firmInputValue.toLowerCase();
        setFirmOptions(firmAllOptions.filter(o => o.label.toLowerCase().includes(q)));
    }, [firmInputValue, firmAllOptions]);

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setSnackbarOpen(false);
    };

    const handleRowSelection = (row, checked) => {
        const rowClientId = String(row.clientId ?? row.PartyID ?? '');
        const rowPOIdStr = String(row.POId ?? '');

        if (checked) {
            if (selectedRows.length > 0) {
                const firstClientId = String(selectedRows[0].clientId ?? selectedRows[0].PartyID ?? '');
                if (rowClientId !== firstClientId) {
                    setSnackbarMessage('Cannot select orders with different Client IDs.');
                    setSnackbarSeverity('warning');
                    setSnackbarOpen(true);
                    return;
                }
            }

            setSelectedRows(prev => {
                const exists = prev.some(r => String(r.POId ?? '') === rowPOIdStr);
                return exists ? prev : [...prev, row];
            });
            setSelectedRowIds(prev => prev.includes(rowPOIdStr) ? prev : [...prev, rowPOIdStr]);
        } else {
            setSelectedRows(prev => prev.filter(r => String(r.POId ?? '') !== rowPOIdStr));
            setSelectedRowIds(prev => prev.filter(id => id !== rowPOIdStr));
        }
    };

    // Filtered data for small screens
    const filteredPendingOrders = useMemo(() => {
        if (!searchQuery) return pendingOrders;
        const q = searchQuery.toLowerCase();
        return pendingOrders.filter(row =>
            String(row.PONumber || "").toLowerCase().includes(q) ||
            String(row.PartyName || "").toLowerCase().includes(q)
        );
    }, [pendingOrders, searchQuery]);

    const filteredChallanRows = useMemo(() => {
        if (!searchQuery) return challanRows;
        const q = searchQuery.toLowerCase();
        return challanRows.filter(row =>
            String(row.ChallanNumber || "").toLowerCase().includes(q) ||
            String(row.FirmName || "").toLowerCase().includes(q)
        );
    }, [challanRows, searchQuery]);

    const columns = useMemo(() => [
        {
            field: 'select', headerName: '', width: 50, sortable: false, disableColumnMenu: true, filterable: false,
            renderHeader: () => {
                const allSelected = pendingOrders.length > 0 && pendingOrders.every(row => selectedRowIds.includes(String(row.POId ?? '')));
                const someSelected = selectedRowIds.length > 0 && !allSelected;

                return (
                    <Checkbox checked={allSelected} indeterminate={someSelected}
                        onChange={(e) => {
                            const checked = e.target.checked;
                            if (checked) {
                                const firstClientId = selectedRows.length > 0 ? String(selectedRows[0].clientId ?? selectedRows[0].PartyID ?? '') : String(pendingOrders[0]?.clientId ?? pendingOrders[0]?.PartyID ?? '');
                                if (!firstClientId) {
                                    setSelectedRows([]);
                                    setSelectedRowIds([]);
                                    return;
                                }
                                const validRows = pendingOrders.filter(row => String(row.clientId ?? row.PartyID ?? '') === firstClientId);
                                setSelectedRows(validRows);
                                setSelectedRowIds(validRows.map(row => String(row.POId ?? '')));

                                if (validRows.length < pendingOrders.length) {
                                    setSnackbarMessage('Selected orders with matching Client ID only.');
                                    setSnackbarSeverity('info');
                                    setSnackbarOpen(true);
                                }
                            } else {
                                setSelectedRows([]);
                                setSelectedRowIds([]);
                            }
                        }}
                    />
                );
            },
            renderCell: ({ row }) => {
                const rowIdStr = String(row.POId ?? '');
                const checked = selectedRowIds.includes(rowIdStr);
                return (<Checkbox checked={checked} onChange={(e) => handleRowSelection(row, e.target.checked)} />);
            },
        },
        { field: "PODate", headerName: "PO Date", flex: 0.8, sortable: true, filterable: true, valueGetter: (value) => normalizeDate(value), valueFormatter: (params) => normalizeDate(params) },
        { field: "PONumber", headerName: "PO No.", flex: 1.2 },
        // { field: "PartyPONO", headerName: "Ref No.", flex: 1 },
        {
            field: "PartyName", headerName: "FirmName", flex: 2.5,
            renderCell: (params) => (
                <Box sx={{ cursor: 'pointer', whiteSpace: 'normal', wordBreak: 'break-word', my: 1 }}>
                    <Typography variant="subtitle2" sx={{ fontSize: '0.85rem' }}> {params.row.PartyName || '-'} </Typography>
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <FaUser color={themeColors.warning.main} />
                        <Typography variant="body2">{params.row.ContactPerson || '-'}</Typography>
                    </Stack>
                    <Typography variant="body2" color="text.secondary"> 📲 {params.row.MobileNo || '-'} </Typography>
                </Box>
            ),
        },
        {
            field: 'City', headerName: 'Location', flex: 0.5, align: 'right', headerAlign: 'right', filterable: true,
            valueGetter: (value, row) => [row.City, row.state].filter(Boolean).join(', '),
            renderCell: (params) => (
                <Box>
                    <Typography variant="body2" fontWeight={600}>{params.row.City || 'N/A'}</Typography>
                    <Typography variant="body2" color="text.secondary">{params.row.state || '-'}</Typography>
                </Box>
            )
        },
        ...(user?.UserCategory !== "SalesMan" ? [{
            field: "BillAmt", headerName: "Total Amt", flex: 1, align: "right", headerAlign: "right",
            valueFormatter: (params) => {
                let num = Number(params);
                if (typeof num === "string") num = parseFloat(num);
                if (typeof num !== "number" || isNaN(num)) return "-";
                return `₹${num.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
            },
        }] : []),
    ], [user?.UserCategory, pendingOrders, selectedRowIds, selectedRows, handleRowSelection, normalizeDate, setSnackbarMessage, setSnackbarSeverity, setSnackbarOpen, setSelectedRows, setSelectedRowIds]);

    const challanColumns = [
        { field: 'ChallanDate', headerName: 'Date', flex: 0.8, sortable: true, filterable: true, },
        {
            field: 'ChallanNumber', headerName: 'Challan Number', flex: 1.2,
            renderCell: (params) => (
                <Box>
                    <Typography variant="body2" sx={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); navigate(`/main/Purchase-ChallanMaster-edit/${params.row.ChallanAutoID}`, { state: { clientId: params.row.clientId, challanId: params.row.ChallanAutoID } }); }} > {params.value ?? '-'} </Typography>
                </Box>
            ),
        },
        { field: 'RefNo', headerName: 'Ref No.', flex: 1 },
        {
            field: 'clientname', headerName: 'FirmName', flex: 2.5,
            renderCell: (params) => (
                <Box sx={{ cursor: 'pointer', whiteSpace: 'normal', wordBreak: 'break-word', my: 1 }}>
                    <Typography variant='subtitle2' sx={{ fontSize: '0.85rem' }}>{params.row.FirmName || '-'}</Typography>
                    <Stack direction='row' alignItems='center' spacing={1}>
                        <FaUser color={themeColors.warning.main} />
                        <Typography variant='body2'>{params.row.ContactPerson || '-'}</Typography>
                    </Stack>
                    <Typography variant='body2' color='text.secondary'>📲 {params.row.MobileNo || '-'}</Typography>
                </Box>
            ),
        },
        {
            field: 'location', headerName: 'Location', flex: 1.5, filterable: true,
            valueGetter: (value, row) => [row.City, row.state].filter(Boolean).join(', '),
            renderCell: (params) => (
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="body2">{params.row.City || '-'}</Typography>
                    <Typography variant="caption" color="text.secondary">{params.row.state || '-'}</Typography>
                </Box>
            ),
        },
        {
            field: 'BillAmt', headerName: 'Total Amt', flex: 1, type: 'number', align: 'right', headerAlign: 'right',
            valueFormatter: (params) => {
                const num = Number(params)
                // const num = params.value;
                if (typeof num !== 'number' || isNaN(num)) return '-';
                return `₹${num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
            },
        },
        {
            field: 'actions', headerName: 'Action', flex: 0.8, align: 'right', headerAlign: 'right', sortable: false, filterable: false,
            renderCell: (params) => (
                <IconButton color="primary" onClick={() => handleView(params.row.ChallanId)}>
                    <PrintIcon />
                </IconButton>
            ),
        }
    ];

    if (role !== "User") {
        challanColumns.unshift({
            field: 'select', headerName: '', width: 50, sortable: false, disableColumnMenu: true, filterable: false,
            renderHeader: () => {
                const allSelected = challanRows.length > 0 && challanRows.every(row => challanSelectionModel.includes(Number(row.ChallanId)));
                const someSelected = challanSelectionModel.length > 0 && !allSelected;

                return (
                    <Checkbox checked={allSelected} indeterminate={someSelected}
                        onChange={(e) => {
                            const checked = e.target.checked;
                            setChallanSelectionModel(checked ? challanRows.map(row => Number(row.ChallanId)) : []);
                        }}
                    />
                );
            },
            renderCell: ({ row }) => {
                const rowIdNum = Number(row.ChallanId);
                const checked = challanSelectionModel.includes(rowIdNum);

                return (
                    <Checkbox checked={checked}
                        onChange={(e) => {
                            const checkedNow = e.target.checked;
                            setChallanSelectionModel(prev => {
                                if (checkedNow) {
                                    if (!prev.includes(rowIdNum)) return [...prev, rowIdNum];
                                    return prev;
                                } else {
                                    return prev.filter(id => id !== rowIdNum);
                                }
                            });
                        }}
                    />
                );
            },
        });

        challanColumns.push({
            field: 'delete', headerName: 'Delete', flex: 0.6, align: 'right', headerAlign: 'right', sortable: false, filterable: false,
            renderCell: (params) => {
                const isSelected = challanSelectionModel.includes(Number(params.row.ChallanId));
                return (
                    <Tooltip title={isSelected ? 'Delete selected challans' : 'Select row to enable delete'}>
                        <span>
                            <IconButton color="error" onClick={() => handleChallanDelete(challanSelectionModel)} disabled={!isSelected} size="small">
                                <DeleteIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                );
            },
        });
    }

    // Card renderers for small screens
    const renderPendingOrderCard = (row) => {
        const isSelected = selectedRowIds.includes(String(row.POId));
        const avatarColor = stringToColor(row.PartyName || 'Order');
        const initials = getInitials(row.PartyName);

        return (
            <Card key={row.POId} sx={{ mb: 2, borderLeft: `6px solid ${themeColors.warning.main}`, borderRadius: 2, overflow: 'hidden', boxShadow: 1 }} >
                <CardContent sx={{ p: 2 }}>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                        <Box display="flex" alignItems="center" flex={1} pr={2}>
                            <Checkbox checked={isSelected} onChange={(e) => handleRowSelection(row, e.target.checked)} onClick={(e) => e.stopPropagation()} />
                            <Avatar sx={{ bgcolor: avatarColor, color: themeColors.neutral.surface, width: 32, height: 32, mr: 2, fontWeight: 'bold' }}> {initials} </Avatar>
                            <Box flex={1}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}> {row.PartyName || 'N/A'} </Typography>
                                <Typography variant="caption" color="text.secondary"> {row.City || ''}, {row.state || ''} </Typography>
                            </Box>
                        </Box>
                        <Typography variant="caption" sx={{ minWidth: 80, textAlign: 'right' }}> {normalizeDate(row.PODate)} </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between" mb={1}>
                        <Box display="flex" alignItems="center" flex={1}>
                            <DescriptionIcon sx={{ fontSize: 16, color: 'text.secondary', mr: 1 }} />
                            <Typography variant="body2" color="text.secondary"> {row.PONumber || 'N/A'} </Typography>
                        </Box>
                        <Typography variant="body1" sx={{ fontWeight: 600 }}> ₹{(row.BillAmt || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })} </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between" mb={1}>
                        <Box display="flex" alignItems="center">
                            <PersonIcon sx={{ fontSize: 16, color: 'text.secondary', mr: 1 }} />
                            <Typography variant="body2" color="text.secondary"> {row.ContactPerson || 'N/A'} </Typography>
                        </Box>
                    </Box>
                    <Divider sx={{ my: 1 }} />
                    <Box display="flex" justifyContent="space-between">
                        <Box display="flex" alignItems="center" flex={1}>
                            <PhoneAndroidIcon sx={{ fontSize: 16, color: 'text.secondary', mr: 1 }} />
                            <Typography variant="body2" color="text.secondary"> {row.MobileNo || 'N/A'} </Typography>
                        </Box>
                        <Box />
                    </Box>
                </CardContent>
            </Card>
        );
    };

    const renderChallanCard = (row) => {
        const isSelected = challanSelectionModel.includes(Number(row.ChallanId));
        const avatarColor = getAvatarColor(row.FirmName || 'Challan');
        const initials = getInitials(row.FirmName);
        const hasReference = Boolean(row.RefNo);
        return (
            <Card
                sx={{ mb: 2, borderLeft: `6px solid ${hasReference ? themeColors.warning.main : themeColors.primary.main}`, borderRadius: '12px', overflow: 'hidden', boxShadow: 2, '&:hover': { boxShadow: 4 }, cursor: 'pointer', transition: '0.2s' }} onClick={() => navigate(`/main/Purchase-ChallanMaster-edit/${row.ChallanAutoID}`, { state: { clientId: row.clientId, challanId: row.ChallanAutoID } })} >
                <CardContent sx={{ p: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                            {/* Checkbox with stopPropagation to prevent card navigation */}
                            {role !== 'User' && (
                                <Box onClick={(e) => e.stopPropagation()} sx={{ display: 'flex', alignItems: 'center', mr: 1 }} >
                                    <Checkbox checked={isSelected} onChange={(e) => { e.stopPropagation(); const checked = e.target.checked; setChallanSelectionModel(prev => checked ? [...prev, Number(row.ChallanId)] : prev.filter(id => id !== Number(row.ChallanId))); }} sx={{ p: 0.5 }} />
                                </Box>
                            )}
                            <Avatar sx={{ width: 32, height: 32, bgcolor: avatarColor, color: themeColors.neutral.surface, fontWeight: 'bold', mr: 1.5, flexShrink: 0 }}> {initials} </Avatar>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'text.primary' }}> {row.FirmName || '—'} </Typography>
                                <Typography variant="caption" color="text.secondary"> {row.City && row.state ? `${row.City}, ${row.state}` : '—'} </Typography>
                            </Box>
                        </Box>
                        <Typography variant="caption" sx={{ minWidth: '80px', textAlign: 'right', color: 'text.secondary' }}> {row.ChallanDate || '—'} </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1, mt: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <PrintIcon sx={{ fontSize: 16, color: 'text.secondary', mr: 1 }} />
                            <Typography variant="body2" sx={{ color: 'primary.main', fontWeight: 500 }}> {row.ChallanNumber || '—'} </Typography>
                        </Box>
                        <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary' }}> {formatCurrencyINR(row.BillAmt)} </Typography>
                    </Box>

                    <Box sx={{ mb: 0.8 }}>
                        {hasReference ? (
                            <Chip
                                label={`Ref: ${row.RefNo}`}
                                size="small"
                                sx={{
                                    bgcolor: themeColors.warning.tint,
                                    color: '#E65100',
                                    fontWeight: 500
                                }}
                            />
                        ) : (
                            <Chip
                                label="Manual"
                                size="small"
                                sx={{ bgcolor: '#e7f5ff', color: "#0067bb" }}
                            />
                        )}
                    </Box>

                    <Divider sx={{ my: 1 }} />

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <PersonIcon sx={{ fontSize: 16, color: 'text.secondary', mr: 1 }} />
                            <Typography variant="body2" sx={{ color: 'text.secondary' }}> {row.ContactPerson || '—'} </Typography>
                        </Box>
                        {/* View PDF button with stopPropagation */}
                        <IconButton color="primary" onClick={(e) => { e.stopPropagation(); handleView(row.ChallanId); }} size="small" >
                            <PrintIcon />
                        </IconButton>
                    </Box>
                </CardContent>
            </Card>
        );
    };

    return (
        <Box sx={{ pt: 0.7, px: { xs: 2, sm: 3, md: 4 } }}>
            {/* <Box my={1} mx={isMobile ? 2 : 0}> */}



            {/* ── Module Header ──────────────────────────────────────────────
                If purchase order rows are selected, the Add button creates a
                Purchase Challan from those orders; else opens blank form.
            ────────────────────────────────────────────────────────────────── */}
            <Box sx={{ mb: 2 }}>
                <Box sx={{ height: 4, background: gradients.primaryRow, borderRadius: '6px 6px 0 0' }} />
                <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderTop: 0, borderRadius: '0 0 8px 8px', px: 2, py: 1.2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography variant="h6" fontWeight={700} color="primary.main" sx={{ fontSize: '1.05rem' }}>
                        Purchase Challans
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button variant="outlined" size="small" startIcon={<FilterAltIcon />} onClick={openFilterPopup} sx={{ textTransform: 'none' }}>Filter</Button>
                        {/* Toggle linked pending orders panel */}
                        {/* <Button variant='contained' size='small' color='primary' onClick={handleTogglePending}>{showPending ? 'Hide' : 'Show'} Pending</Button> */}
                        {/* If purchase order rows selected → create challan from them; else open blank form */}
                        <Button variant="contained" size="small" startIcon={<AddIcon />}
                            onClick={() => {
                                if (selectedRows.length > 0) {
                                    handleDispatch();
                                } else {
                                    navigate("/main/Purchase-ChallanMaster-stepper");
                                }
                            }}
                        >
                            {isSmallDevice ? 'Add' : 'Add Purchase Challan'}
                        </Button>
                    </Box>
                </Paper>
            </Box>

            <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden', width: '100%' }}>
                <Box sx={{ p: { xs: 0.5, md: 0.5 } }}>
                    {/* Search field only on small screens */}
                    {isSmallScreen && (
                        <Box mb={2}>
                            <TextField fullWidth size="small" placeholder={showPending ? "Search orders..." : "Search challans..."} value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>
                    )}

                    {/* Bulk action bar for challans on small screen */}
                    {isSmallScreen && !showPending && role !== "User" && challanSelectionModel.length > 0 && (
                        <Box display="flex" justifyContent="space-between" alignItems="center" p={1.5} mb={2} bgcolor="background.paper" borderRadius={2} boxShadow={1}>
                            <Box display="flex" alignItems="center">
                                <Checkbox checked={challanRows.length > 0 && challanSelectionModel.length === challanRows.length} indeterminate={challanSelectionModel.length > 0 && challanSelectionModel.length < challanRows.length}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setChallanSelectionModel(challanRows.map(r => Number(r.ChallanId)));
                                        } else {
                                            setChallanSelectionModel([]);
                                        }
                                    }}
                                />
                                <Typography variant="body2">{challanSelectionModel.length} selected</Typography>
                            </Box>
                            <IconButton color="error" onClick={() => handleChallanDelete(challanSelectionModel)}>
                                <DeleteIcon />
                            </IconButton>
                        </Box>
                    )}

                    <Collapse in={showPending}>
                        {/* <Box px={isMobile ? 2 : 0} mb={3}>
                        <Paper sx={{ p: 2, borderRadius: 3 }}> */}
                        {loadingPending || loading ? (
                            <SkeletonLoader count={2} height={120} />
                        ) : isSmallScreen ? (
                            <Paper sx={{ borderRadius: 3, p: 1.5, overflow: 'hidden' }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                                    <Typography variant="h6" fontWeight={600}>Purchase Order List</Typography>
                                </Box>
                                {
                                    pendingOrders.length === 0 ? <NoDataComponent /> : (
                                        <>
                                            {filteredPendingOrders.length === 0 && <CustomNoDataOverlay />}
                                            {filteredPendingOrders.map(row => (
                                                renderPendingOrderCard(row)))}</>)
                                }

                            </Paper>
                        ) : (
                            <Paper elevation={2} sx={{ borderRadius: 3, p: 1.5, overflow: 'hidden', mb: 3 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                                    <Typography variant="h6" fontWeight={600}>Purchase Order List</Typography>
                                </Box>
                                <Box sx={{ height: '71vh', width: '100%' }}>
                                    {
                                        pendingOrders?.length === 0 ? <NoDataComponent /> :
                                            <DataGrid rows={pendingOrders} columns={columns} getRowId={(row) => String(row.POId)} initialState={{ pagination: { paginationModel: { pageSize: 100, page: 0 } } }} pageSizeOptions={[50, 100]} getRowHeight={() => 'auto'}
                                                sx={{
                                                    // Column header styling
                                                    '& .MuiDataGrid-columnHeaders': { backgroundColor: themeColors.neutral.gridHeader, borderBottom: `1px solid ${themeColors.neutral.border}` },
                                                    '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 700 },
                                                    '& .MuiDataGrid-columnHeader': { backgroundColor: themeColors.neutral.gridHeader, color: themeColors.neutral.ink, fontWeight: 700, fontSize: '0.74rem', textTransform: 'uppercase', letterSpacing: '0.06em' },

                                                    // Background styling
                                                    '& .MuiDataGrid-filler': { backgroundColor: themeColors.neutral.surface },
                                                    '& .MuiDataGrid-scrollbarFiller': { backgroundColor: themeColors.neutral.gridHeader },

                                                    // Row styling
                                                    '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: themeColors.neutral.surface },
                                                    '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: themeColors.neutral.surfaceAlt },
                                                    '& .MuiDataGrid-row:hover': { backgroundColor: themeColors.primary.tint },

                                                    // Selected row styling (with !important to override default MUI)
                                                    '& .MuiDataGrid-row.Mui-selected': { backgroundColor: `${themeColors.primary.selected} !important` },

                                                    // Cell content alignment
                                                    '& .MuiDataGrid-cell': {
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    },

                                                    // Merge custom styles from parent
                                                    // ...sxProp,
                                                }}
                                                slots={{
                                                    noResultsOverlay: CustomNoDataOverlay
                                                }}
                                            />}
                                </Box>
                            </Paper>
                        )}
                        {/* </Paper>
                    </Box> */}
                    </Collapse>

                    {isSmallScreen ? (
                        <Paper sx={{ borderRadius: 3, p: 1.5, overflow: 'hidden', display: !showPending ? 'block' : 'none' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                                <Typography variant='h6' fontWeight={600}>Purchase Challan List</Typography>
                            </Box>
                            {challanLoading && <SkeletonLoader count={2} height={120} />}
                            {!challanLoading && challanRows?.length === 0 && <NoDataComponent />}
                            {!challanLoading && challanRows?.length > 0 && (<>
                                {(filteredChallanRows.length === 0) && <Typography sx={{ p: 4, textAlign: 'center' }}><CustomNoDataOverlay /></Typography>}
                                {filteredChallanRows.map(row => (<Box key={row.ChallanId}>
                                    {renderChallanCard(row)}
                                </Box>))}</>)
                            }

                        </Paper>
                    ) : (
                        <Paper elevation={2} sx={{ borderRadius: 3, p: 0.5, overflow: 'hidden' }}>
                            {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                                <Typography variant='h6' fontWeight={600}>Purchase Challan List</Typography>
                            </Box> */}
                            <Box sx={{ height: '71vh', width: '100%', position: 'relative' }}>
                                <LoadingOverlay isVisible={challanLoading} />
                                {!challanLoading && challanRows?.length === 0 && <NoDataComponent />}
                                {!challanLoading && challanRows?.length > 0 && <DataGrid rows={challanRows} getRowHeight={() => 'auto'} getRowId={(row) => row.ChallanId} pageSizeOptions={[50, 100]} columns={challanColumns}
                                        sx={{
                                            // Column header styling
                                            '& .MuiDataGrid-columnHeaders': { backgroundColor: themeColors.neutral.gridHeader, borderBottom: `1px solid ${themeColors.neutral.border}` },
                                            '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 700 },
                                            '& .MuiDataGrid-columnHeader': { backgroundColor: themeColors.neutral.gridHeader, color: themeColors.neutral.ink, fontWeight: 700, fontSize: '0.74rem', textTransform: 'uppercase', letterSpacing: '0.06em' },

                                            // Background styling
                                            '& .MuiDataGrid-filler': { backgroundColor: themeColors.neutral.surface },
                                            '& .MuiDataGrid-scrollbarFiller': { backgroundColor: themeColors.neutral.gridHeader },

                                            // Row styling
                                            '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: themeColors.neutral.surface },
                                            '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: themeColors.neutral.surfaceAlt },
                                            '& .MuiDataGrid-row:hover': { backgroundColor: themeColors.primary.tint },

                                            // Selected row styling (with !important to override default MUI)
                                            '& .MuiDataGrid-row.Mui-selected': { backgroundColor: `${themeColors.primary.selected} !important` },

                                            // Cell content alignment
                                            '& .MuiDataGrid-cell': {
                                                display: 'flex',
                                                alignItems: 'center'
                                            },

                                            // Merge custom styles from parent
                                            // ...sxProp,
                                        }}
                                        slots={{
                                            noResultsOverlay: CustomNoDataOverlay
                                        }}
                                    />}
                            </Box>
                        </Paper>
                    )}

                </Box>
            </Paper>
            {/* </Box> */}

            <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }} variant='filled'>
                    {snackbarMessage}
                </Alert>
            </Snackbar>

            {pdfError && <Alert severity="error" sx={{ mt: 2 }}>PDF Error: {pdfError}</Alert>}
            {pdfLoading && <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                <CircularProgress size={18} /> <Typography>Preparing PDF...</Typography>
            </Box>}
            {pdfUri && <Box sx={{ mt: 2 }}><PdfViewer uri={pdfUri} /></Box>}

            {pdfOverlayVisible && (
                <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, bgcolor: 'rgba(0,0,0,0.92)', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Box sx={{ textAlign: 'center', bgcolor: '#111', p: '40px 60px', borderRadius: 4 }}>
                        <CircularProgress size={60} thickness={4} sx={{ color: themeColors.neutral.surface }} />
                        <Typography variant="h6" sx={{ color: themeColors.neutral.surface, mt: 3 }}>Generating Purchase Challan PDF…</Typography>
                        <Typography variant="body2" sx={{ color: themeColors.neutral.muted, mt: 1 }}>Please wait</Typography>
                    </Box>
                </Box>
            )}

            {/* ── Delete Confirmation Dialog ──────────────────────────── */}
            <Dialog open={openChallanDeleteDialog} onClose={() => { if (!deleting) setOpenChallanDeleteDialog(false); }} maxWidth="xs" fullWidth>
                {deleting
                    ? <LinearProgress color="error" sx={{ height: 4 }} />
                    : <Box sx={{ height: 4, background: gradients.danger }} />}
                <Box sx={{ px: 2.5, pt: 2, pb: 1.5 }}>
                    <Typography variant="h6" fontWeight={700} sx={{ color: 'error.main', fontSize: '1.05rem' }}>Confirm Deletion</Typography>
                </Box>
                <Divider />
                <Box sx={{ px: 2.5, py: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                        Are you sure you want to delete{' '}
                        <Typography component="span" variant="body2" fontWeight={700} color="error.main">{pendingChallanDeleteIds.length}</Typography>
                        {' '}purchase challan(s)? This action cannot be undone.
                    </Typography>
                </Box>
                <Divider />
                <Box sx={{ px: 2.5, py: 1.5, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button onClick={() => setOpenChallanDeleteDialog(false)} variant="outlined" color="inherit" size="small" disabled={deleting}>Cancel</Button>
                    <Button onClick={confirmChallanDelete} color="error" variant="contained" size="small" disabled={deleting}
                        startIcon={deleting ? <CircularProgress size={14} color="inherit" /> : <DeleteIcon />}>{deleting ? 'Deleting…' : 'Delete'}</Button>
                </Box>
            </Dialog>

            {/* Filter Dialog */}
            <Dialog
                open={filterPopupOpen}
                onClose={cancelFilterPopup}
                fullWidth
                maxWidth="sm"
                PaperProps={{ sx: { borderRadius: 2, boxShadow: '0 4px 20px rgba(0,0,0,0.1)' } }}
            >
                {/* Header */}
                <DialogTitle
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        pb: 1.5,
                        pt: 2,
                        px: 3,
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: 'white'
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Box
                            sx={{
                                bgcolor: 'rgba(255,255,255,0.2)',
                                borderRadius: '50%',
                                p: 0.8,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <FilterListIcon sx={{ color: 'white', fontSize: 20 }} />
                        </Box>
                        <Typography variant="h6" fontWeight={600} sx={{ fontSize: '1.1rem' }}>
                            Filter Options
                        </Typography>
                    </Box>
                    <IconButton
                        onClick={cancelFilterPopup}
                        size="small"
                        sx={{
                            color: 'white',
                            bgcolor: 'rgba(255,255,255,0.15)',
                            '&:hover': { bgcolor: 'rgba(255,255,255,0.25)' }
                        }}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ px: 3, py: 2, bgcolor: themeColors.neutral.surfaceAlt }}>
                    {/* Filter Mode Selection */}
                    <Paper
                        elevation={0}
                        sx={{
                            p: 2,
                            mb: 1,
                            mt: 1,
                            bgcolor: 'white',
                            border: `1px solid ${themeColors.neutral.line}`,
                            borderRadius: 2,
                            boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                            <Box sx={{ width: 4, height: 20, bgcolor: 'primary.main', borderRadius: 1 }} />
                            <Typography variant="subtitle1" fontWeight={600} sx={{ color: 'text.primary' }}>
                                Filter Mode
                            </Typography>
                        </Box>
                        <RadioGroup
                            row
                            value={filterPopupMode}
                            onChange={(e) => setFilterPopupMode(e.target.value)}
                            sx={{ display: 'flex', gap: 2 }}
                        >
                            <FormControlLabel
                                value="datewise"
                                control={
                                    <Radio
                                        size="small"
                                        sx={{
                                            '&.Mui-checked': { color: 'primary.main' }
                                        }}
                                    />
                                }
                                label={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        <Typography variant="body2" fontWeight={500}>
                                            📅 Datewise
                                        </Typography>
                                    </Box>
                                }
                                sx={{
                                    flex: 1,
                                    m: 0,
                                    bgcolor: filterPopupMode === 'datewise' ? themeColors.primary.tint : themeColors.neutral.surfaceMuted,
                                    borderRadius: 1.5,
                                    px: 2,
                                    py: 0.5,
                                    border: filterPopupMode === 'datewise' ? '2px solid' : '2px solid transparent',
                                    borderColor: 'primary.main',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        bgcolor: filterPopupMode === 'datewise' ? themeColors.primary.tint : themeColors.neutral.border,
                                    }
                                }}
                            />
                            <FormControlLabel
                                value="partywise"
                                control={
                                    <Radio
                                        size="small"
                                        sx={{
                                            '&.Mui-checked': {
                                                color: 'primary.main',
                                            }
                                        }}
                                    />
                                }
                                label={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        <Typography variant="body2" fontWeight={500}>
                                            👥 Partywise
                                        </Typography>
                                    </Box>
                                }
                                sx={{
                                    flex: 1,
                                    m: 0,
                                    bgcolor: filterPopupMode === 'partywise' ? themeColors.primary.tint : themeColors.neutral.surfaceMuted,
                                    borderRadius: 1.5,
                                    px: 2,
                                    py: 0.5,
                                    border: filterPopupMode === 'partywise' ? '2px solid' : '2px solid transparent',
                                    borderColor: 'primary.main',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        bgcolor: filterPopupMode === 'partywise' ? themeColors.primary.tint : themeColors.neutral.border,
                                    }
                                }}
                            />
                        </RadioGroup>
                    </Paper>

                    {/* Filter Fields */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        {/* Date Range */}
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                bgcolor: 'white',
                                border: `1px solid ${themeColors.neutral.line}`,
                                borderRadius: 2,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                <Box sx={{ width: 4, height: 20, bgcolor: '#ff6b6b', borderRadius: 1 }} />
                                <Typography variant="subtitle2" fontWeight={600} sx={{ color: 'text.primary' }}>
                                    📆 Date Range
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', gap: 2 }}>
                                <Box sx={{ flex: 1 }}>
                                    <Typography
                                        variant="caption"
                                        fontWeight={600}
                                        sx={{ mb: 0.5, display: 'block', color: 'text.secondary' }}
                                    >
                                        From Date
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        type="date"
                                        value={filterPopupFromDate}
                                        onChange={(e) => setFilterPopupFromDate(e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                bgcolor: themeColors.neutral.surfaceAlt,
                                                borderRadius: 1.5,
                                                '&:hover': { bgcolor: themeColors.neutral.surfaceMuted },
                                                '&.Mui-focused': { bgcolor: 'white' }
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': { borderColor: themeColors.neutral.line }
                                        }}
                                    />
                                </Box>
                                <Box sx={{ flex: 1 }}>
                                    <Typography
                                        variant="caption"
                                        fontWeight={600}
                                        sx={{ mb: 0.5, display: 'block', color: 'text.secondary' }}
                                    >
                                        To Date
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        type="date"
                                        value={filterPopupToDate}
                                        onChange={(e) => setFilterPopupToDate(e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                bgcolor: themeColors.neutral.surfaceAlt,
                                                borderRadius: 1.5,
                                                '&:hover': { bgcolor: themeColors.neutral.surfaceMuted },
                                                '&.Mui-focused': { bgcolor: 'white' }
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': { borderColor: themeColors.neutral.line }
                                        }}
                                    />
                                </Box>
                            </Box>
                        </Paper>

                        {/* Firm Name */}
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                bgcolor: 'white',
                                border: `1px solid ${themeColors.neutral.line}`,
                                borderRadius: 2,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                <Box sx={{ width: 4, height: 20, bgcolor: '#4ecdc4', borderRadius: 1 }} />
                                <Typography variant="subtitle2" fontWeight={600} sx={{ color: 'text.primary' }}>
                                    🏢 Firm Name
                                </Typography>
                            </Box>
                            <Autocomplete
                                multiple
                                options={firmOptions}
                                value={filterPopupFirms}
                                loading={firmLoading}
                                inputValue={firmInputValue}
                                onInputChange={(_, v) => setFirmInputValue(v)}
                                onChange={(_, v) => setFilterPopupFirms(v)}
                                getOptionLabel={o => o.label || ''}
                                isOptionEqualToValue={(o, v) => o.id === v.id}
                                renderTags={() => null}
                                renderOption={(props, option, { selected }) => (
                                    <li {...props}>
                                        <Checkbox
                                            checked={selected}
                                            size="small"
                                            sx={{
                                                mr: 1,
                                                color: '#4ecdc4',
                                                '&.Mui-checked': { color: '#4ecdc4' }
                                            }}
                                        />
                                        <Typography variant="body2">{option?.label || ''}</Typography>
                                    </li>
                                )}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        size="small"
                                        fullWidth
                                        placeholder={filterPopupFirms?.length ? `${filterPopupFirms.length} firm(s) selected` : 'Select firms (ALL)'}
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                bgcolor: themeColors.neutral.surfaceAlt,
                                                borderRadius: 1.5,
                                                '&:hover': { bgcolor: themeColors.neutral.surfaceMuted },
                                                '&.Mui-focused': { bgcolor: 'white' }
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': { borderColor: themeColors.neutral.line }
                                        }}
                                        InputProps={{
                                            ...params.InputProps,
                                            startAdornment: (
                                                <>
                                                    {filterPopupFirms?.length > 0 && (
                                                        <Chip
                                                            label={`${filterPopupFirms.length}`}
                                                            size="small"
                                                            sx={{
                                                                ml: 0.5,
                                                                height: 22,
                                                                bgcolor: '#4ecdc4',
                                                                color: 'white',
                                                                fontWeight: 700,
                                                                fontSize: '0.75rem'
                                                            }}
                                                        />
                                                    )}
                                                    {params.InputProps.startAdornment}
                                                </>
                                            ),
                                            endAdornment: (
                                                <>
                                                    {firmLoading ? <CircularProgress size={16} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            )
                                        }}
                                    />
                                )}
                                PaperComponent={props => <Paper elevation={4} {...props} />}
                                ListboxProps={{ style: { maxHeight: 200 } }}
                            />
                        </Paper>
                    </Box>
                </DialogContent>

                <DialogActions
                    sx={{
                        px: 3,
                        py: 1.5,
                        bgcolor: themeColors.neutral.surfaceAlt,
                        borderTop: `1px solid ${themeColors.neutral.line}`,
                        gap: 2
                    }}
                >
                    <Button
                        onClick={cancelFilterPopup}
                        variant="outlined"
                        sx={{
                            flex: 1,
                            borderRadius: 2,
                            textTransform: 'none',
                            fontWeight: 600,
                            py: 1,
                            borderColor: themeColors.neutral.line,
                            color: 'text.secondary',
                            '&:hover': { borderColor: themeColors.neutral.muted, bgcolor: themeColors.neutral.surfaceMuted }
                        }}
                    >
                        ✕ Cancel
                    </Button>

                    {/* Export Excel Button */}
                    <Button
                        onClick={handleExportExcel}
                        variant="outlined"
                        disabled={!exportExcelEnabled}
                        sx={{
                            flex: 1, borderRadius: 2, textTransform: 'none', fontWeight: 600, py: 1.2,
                            borderColor: !exportExcelEnabled ? themeColors.neutral.line : themeColors.success.dark,
                            color: !exportExcelEnabled ? 'text.disabled' : themeColors.success.dark,
                            '&:hover': {
                                borderColor: themeColors.success.dark,
                                bgcolor: '#f1f8e9'
                            },
                            '&.Mui-disabled': {
                                borderColor: themeColors.neutral.line,
                                color: 'text.disabled'
                            }
                        }}
                    >
                        📊 Export Excel
                    </Button>

                    <Button
                        onClick={handleFilterOk}
                        variant="contained"
                        sx={{
                            flex: 1,
                            borderRadius: 2,
                            textTransform: 'none',
                            fontWeight: 600,
                            py: 1,
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
                            '&:hover': {
                                background: 'linear-gradient(135deg, #5568d3 0%, #63408a 100%)',
                                boxShadow: '0 6px 16px rgba(102, 126, 234, 0.4)'
                            }
                        }}
                    >
                        ✓ Apply Filters
                    </Button>
                </DialogActions>
            </Dialog>

        </Box>
    );
}